import { css, keyframes } from "@emotion/react";

const loadingCircleKeyframes = keyframes`
 100% {
    transform: rotate(360deg);
  }
`;

//A

export const ArrowLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-back">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23 1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const ArrowCompare = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.18367 12.44H18.93C19.4765 12.44 19.92 12.8835 19.92 13.43C19.92 13.9765 19.4765 14.42 18.93 14.42H7.18367L10.7803 18.7364C11.1308 19.1562 11.0734 19.7809 10.6536 20.1303C10.4685 20.2848 10.2438 20.36 10.02 20.36C9.73688 20.36 9.45572 20.2382 9.2597 20.0036L4.3097 14.0636C4.27109 14.0171 4.25129 13.9626 4.22258 13.9111C4.19882 13.8696 4.17011 13.8339 4.15229 13.7884C4.10774 13.6745 4.08101 13.5547 4.08101 13.434C4.08101 13.433 4.08002 13.431 4.08002 13.43C4.08002 13.429 4.08101 13.427 4.08101 13.426C4.08101 13.3053 4.10774 13.1855 4.15229 13.0716C4.17011 13.0261 4.19882 12.9904 4.22258 12.9489C4.41566 12.6026 4.86258 12.476 5.25896 12.4699L7.18367 12.44Z" />
    <path d="M16.8964 11.52H5.15003C4.60355 11.52 4.16003 11.0764 4.16003 10.53C4.16003 9.98348 4.60355 9.53996 5.15003 9.53996H16.8964L13.2997 5.22356C12.9493 4.8038 13.0067 4.17911 13.4264 3.82964C13.6116 3.6752 13.8363 3.59996 14.06 3.59996C14.3432 3.59996 14.6243 3.72173 14.8204 3.95636L19.7704 9.89636C19.809 9.94289 19.8288 9.99734 19.8575 10.0488C19.8812 10.0904 19.9099 10.126 19.9278 10.1716C19.9723 10.2854 19.999 10.4052 19.999 10.526C19.999 10.527 20 10.529 20 10.53C20 10.5309 19.999 10.5329 19.999 10.5339C19.999 10.6547 19.9723 10.7745 19.9278 10.8883C19.9099 10.9339 19.8812 10.9695 19.8575 11.0111C19.6644 11.3573 19.2175 11.4839 18.8211 11.4901L16.8964 11.52Z" />
  </svg>
);

export const ChevronLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-ios-back">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M13.83 19a1 1 0 0 1-.78-.37l-4.83-6a1 1 0 0 1 0-1.27l5-6a1 1 0 0 1 1.54 1.28L10.29 12l4.32 5.36a1 1 0 0 1-.78 1.64z" />
      </g>
    </g>
  </svg>
);

export const CaretDownFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-downward">
        <rect
          width="24"
          height="24"
          transform="rotate(-90 12 12)"
          opacity="0"
        />
        <path d="M12 17a1.72 1.72 0 0 1-1.33-.64l-4.21-5.1a2.1 2.1 0 0 1-.26-2.21A1.76 1.76 0 0 1 7.79 8h8.42a1.76 1.76 0 0 1 1.59 1.05 2.1 2.1 0 0 1-.26 2.21l-4.21 5.1A1.72 1.72 0 0 1 12 17z" />
      </g>
    </g>
  </svg>
);

export const ChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-ios-downward">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 16a1 1 0 0 1-.64-.23l-6-5a1 1 0 1 1 1.28-1.54L12 13.71l5.36-4.32a1 1 0 0 1 1.41.15 1 1 0 0 1-.14 1.46l-6 4.83A1 1 0 0 1 12 16z" />
      </g>
    </g>
  </svg>
);

export const ArrowDown = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.6405 11.1335C15.3455 10.7802 14.8205 10.7318 14.4672 11.0268L10.8339 14.0543V4.16683C10.8339 3.70683 10.4605 3.3335 10.0005 3.3335C9.54052 3.3335 9.16719 3.70683 9.16719 4.16683V14.0543L5.53385 11.0268C5.17969 10.7318 4.65469 10.7802 4.36052 11.1335C4.06552 11.4868 4.11302 12.0127 4.46719 12.3068L9.46719 16.4735C9.50636 16.5068 9.55302 16.5227 9.59636 16.5477C9.63052 16.5677 9.66052 16.591 9.69802 16.606C9.79552 16.6443 9.89719 16.6668 10.0005 16.6668C10.1039 16.6668 10.2055 16.6443 10.303 16.606C10.3405 16.591 10.3705 16.5677 10.4047 16.5477C10.448 16.5227 10.4947 16.5068 10.5339 16.4735L15.5339 12.3068C15.8872 12.0127 15.9355 11.4868 15.6405 11.1335" />
    <mask maskUnits="userSpaceOnUse" x="4" y="3" width="12" height="14">
      <path d="M15.6405 11.1335C15.3455 10.7802 14.8205 10.7318 14.4672 11.0268L10.8339 14.0543V4.16683C10.8339 3.70683 10.4605 3.3335 10.0005 3.3335C9.54052 3.3335 9.16719 3.70683 9.16719 4.16683V14.0543L5.53385 11.0268C5.17969 10.7318 4.65469 10.7802 4.36052 11.1335C4.06552 11.4868 4.11302 12.0127 4.46719 12.3068L9.46719 16.4735C9.50636 16.5068 9.55302 16.5227 9.59636 16.5477C9.63052 16.5677 9.66052 16.591 9.69802 16.606C9.79552 16.6443 9.89719 16.6668 10.0005 16.6668C10.1039 16.6668 10.2055 16.6443 10.303 16.606C10.3405 16.591 10.3705 16.5677 10.4047 16.5477C10.448 16.5227 10.4947 16.5068 10.5339 16.4735L15.5339 12.3068C15.8872 12.0127 15.9355 11.4868 15.6405 11.1335" />
    </mask>
    <g mask="url(#mask0_815_1646)"></g>
  </svg>
);

export const ChevronRightDouble = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9513 5.373L18.7793 11.373C19.0783 11.744 19.0733 12.274 18.7683 12.64L13.7683 18.64C13.5703 18.877 13.2863 19 12.9993 19C12.7743 19 12.5473 18.924 12.3603 18.768C11.9353 18.415 11.8783 17.784 12.2323 17.36L16.7083 11.989L12.3923 6.627C12.0463 6.197 12.1143 5.567 12.5453 5.221C12.9753 4.874 13.6043 4.943 13.9513 5.373ZM5.5452 5.221C5.9752 4.875 6.6042 4.943 6.9512 5.373L11.7792 11.373C12.0772 11.744 12.0732 12.274 11.7682 12.64L6.7682 18.64C6.5702 18.877 6.2862 19 5.9992 19C5.7742 19 5.5472 18.924 5.3602 18.768C4.9352 18.415 4.8782 17.784 5.2322 17.36L9.7072 11.989L5.3922 6.627C5.0462 6.197 5.1152 5.567 5.5452 5.221Z"
    />
    <mask
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x="5"
      y="4"
      width="15"
      height="15"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9513 5.373L18.7793 11.373C19.0783 11.744 19.0733 12.274 18.7683 12.64L13.7683 18.64C13.5703 18.877 13.2863 19 12.9993 19C12.7743 19 12.5473 18.924 12.3603 18.768C11.9353 18.415 11.8783 17.784 12.2323 17.36L16.7083 11.989L12.3923 6.627C12.0463 6.197 12.1143 5.567 12.5453 5.221C12.9753 4.874 13.6043 4.943 13.9513 5.373ZM5.5452 5.221C5.9752 4.875 6.6042 4.943 6.9512 5.373L11.7792 11.373C12.0772 11.744 12.0732 12.274 11.7682 12.64L6.7682 18.64C6.5702 18.877 6.2862 19 5.9992 19C5.7742 19 5.5472 18.924 5.3602 18.768C4.9352 18.415 4.8782 17.784 5.2322 17.36L9.7072 11.989L5.3922 6.627C5.0462 6.197 5.1152 5.567 5.5452 5.221Z"
      />
    </mask>
    <g mask="url(#mask0_0_111)"></g>
  </svg>
);

export const CaretUpFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-up">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M16.21 16H7.79a1.76 1.76 0 0 1-1.59-1 2.1 2.1 0 0 1 .26-2.21l4.21-5.1a1.76 1.76 0 0 1 2.66 0l4.21 5.1A2.1 2.1 0 0 1 17.8 15a1.76 1.76 0 0 1-1.59 1z" />
      </g>
    </g>
  </svg>
);

export const ArrowUp = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.35927 8.86634C4.65427 9.21968 5.17927 9.26801 5.53261 8.97301L9.16594 5.94551V15.833C9.16594 16.293 9.53927 16.6663 9.99927 16.6663C10.4593 16.6663 10.8326 16.293 10.8326 15.833V5.94551L14.4659 8.97301C14.8201 9.26801 15.3451 9.21968 15.6393 8.86634C15.9343 8.51301 15.8868 7.98717 15.5326 7.69301L10.5326 3.52634C10.4934 3.49301 10.4468 3.47717 10.4034 3.45217C10.3693 3.43217 10.3393 3.40884 10.3018 3.39384C10.2043 3.35551 10.1026 3.33301 9.99927 3.33301C9.89594 3.33301 9.79427 3.35551 9.69677 3.39384C9.65927 3.40884 9.62927 3.43217 9.59511 3.45217C9.55177 3.47717 9.50511 3.49301 9.46594 3.52634L4.46594 7.69301C4.11261 7.98717 4.06427 8.51301 4.35927 8.86634Z" />
    <mask maskUnits="userSpaceOnUse" x="4" y="3" width="12" height="14">
      <path d="M4.35927 8.86634C4.65427 9.21968 5.17927 9.26801 5.53261 8.97301L9.16594 5.94551V15.833C9.16594 16.293 9.53927 16.6663 9.99927 16.6663C10.4593 16.6663 10.8326 16.293 10.8326 15.833V5.94551L14.4659 8.97301C14.8201 9.26801 15.3451 9.21968 15.6393 8.86634C15.9343 8.51301 15.8868 7.98717 15.5326 7.69301L10.5326 3.52634C10.4934 3.49301 10.4468 3.47717 10.4034 3.45217C10.3693 3.43217 10.3393 3.40884 10.3018 3.39384C10.2043 3.35551 10.1026 3.33301 9.99927 3.33301C9.89594 3.33301 9.79427 3.35551 9.69677 3.39384C9.65927 3.40884 9.62927 3.43217 9.59511 3.45217C9.55177 3.47717 9.50511 3.49301 9.46594 3.52634L4.46594 7.69301C4.11261 7.98717 4.06427 8.51301 4.35927 8.86634Z" />
    </mask>
  </svg>
);

export const ChevronUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-ios-upward">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M18 15a1 1 0 0 1-.64-.23L12 10.29l-5.37 4.32a1 1 0 0 1-1.41-.15 1 1 0 0 1 .15-1.41l6-4.83a1 1 0 0 1 1.27 0l6 5a1 1 0 0 1 .13 1.41A1 1 0 0 1 18 15z" />
      </g>
    </g>
  </svg>
);

export const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-ios-forward">
        <rect
          width="24"
          height="24"
          transform="rotate(-90 12 12)"
          opacity="0"
        />
        <path d="M10 19a1 1 0 0 1-.64-.23 1 1 0 0 1-.13-1.41L13.71 12 9.39 6.63a1 1 0 0 1 .15-1.41 1 1 0 0 1 1.46.15l4.83 6a1 1 0 0 1 0 1.27l-5 6A1 1 0 0 1 10 19z" />
      </g>
    </g>
  </svg>
);

export const ArrowUpDown = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.26532 0.250732C4.27852 0.250997 4.29171 0.25124 4.30488 0.252197C4.31815 0.25316 4.33135 0.254215 4.34443 0.255859C4.35326 0.256972 4.36199 0.258826 4.37079 0.260254C4.38486 0.262535 4.39875 0.265258 4.41254 0.268311C4.42087 0.27015 4.42917 0.272043 4.43744 0.27417C4.4879 0.28717 4.53597 0.305717 4.58173 0.328369C4.6532 0.363681 4.7207 0.410213 4.78022 0.469727L7.78022 3.46973C8.07307 3.76261 8.07307 4.23739 7.78022 4.53027C7.48733 4.82316 7.01257 4.82314 6.71967 4.53027L4.99994 2.81055V13C4.99994 13.4142 4.66413 13.75 4.24994 13.75C3.83573 13.75 3.49994 13.4142 3.49994 13V2.81055L1.78022 4.53027C1.48733 4.82316 1.01257 4.82314 0.71967 4.53027C0.426777 4.23738 0.426777 3.76262 0.71967 3.46973L3.71967 0.469727C3.76255 0.426853 3.81103 0.389923 3.86322 0.358398C3.87818 0.349363 3.89321 0.340661 3.90863 0.332764C3.95539 0.308804 4.00478 0.289423 4.05658 0.275635C4.06901 0.272324 4.08138 0.268775 4.09394 0.266113C4.10216 0.264374 4.11052 0.263186 4.11884 0.261719C4.13198 0.259392 4.14517 0.257482 4.15839 0.255859C4.17172 0.254238 4.18514 0.25311 4.19867 0.252197C4.21063 0.251378 4.22259 0.250981 4.23456 0.250732C4.23966 0.25063 4.24482 0.25 4.24994 0.25C4.25509 0.25 4.26021 0.250629 4.26532 0.250732Z" />
    <path d="M11.7499 0.25C12.1641 0.250031 12.4999 0.585805 12.4999 1V11.1895L14.2197 9.46973C14.5126 9.17686 14.9873 9.17684 15.2802 9.46973C15.5731 9.76261 15.5731 10.2374 15.2802 10.5303L12.2802 13.5303C12.2453 13.5652 12.2064 13.5958 12.1652 13.6233C12.1359 13.6429 12.1057 13.6603 12.0744 13.6753C12.0403 13.6917 12.005 13.7059 11.9682 13.717C11.9557 13.7209 11.9428 13.7234 11.9301 13.7266C11.9184 13.7295 11.9069 13.733 11.895 13.7354C11.8896 13.7364 11.8842 13.7366 11.8788 13.7375C11.8369 13.7448 11.794 13.75 11.7499 13.75L11.673 13.7463C11.6569 13.7447 11.6412 13.7409 11.6254 13.7383C11.6176 13.737 11.6098 13.7362 11.602 13.7346C11.5934 13.7329 11.5849 13.7308 11.5764 13.7288C11.5609 13.7251 11.5454 13.7217 11.5302 13.717C11.4937 13.7059 11.4586 13.6916 11.4247 13.6753C11.3949 13.6609 11.3657 13.6448 11.3376 13.6262C11.2951 13.5982 11.2555 13.5661 11.2197 13.5303L8.21967 10.5303C7.92678 10.2374 7.92678 9.76262 8.21967 9.46973C8.51257 9.17686 8.98733 9.17684 9.28022 9.46973L10.9999 11.1895V1C10.9999 0.585786 11.3357 0.25 11.7499 0.25Z" />
  </svg>
);

export const AlertTriangle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="alert-triangle">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M22.56 16.3L14.89 3.58a3.43 3.43 0 0 0-5.78 0L1.44 16.3a3 3 0 0 0-.05 3A3.37 3.37 0 0 0 4.33 21h15.34a3.37 3.37 0 0 0 2.94-1.66 3 3 0 0 0-.05-3.04zm-1.7 2.05a1.31 1.31 0 0 1-1.19.65H4.33a1.31 1.31 0 0 1-1.19-.65 1 1 0 0 1 0-1l7.68-12.73a1.48 1.48 0 0 1 2.36 0l7.67 12.72a1 1 0 0 1 .01 1.01z" />
        <circle cx="12" cy="16" r="1" />
        <path d="M12 8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

export const AlertTriangleFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="alert-triangle">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M22.56 16.3L14.89 3.58a3.43 3.43 0 0 0-5.78 0L1.44 16.3a3 3 0 0 0-.05 3A3.37 3.37 0 0 0 4.33 21h15.34a3.37 3.37 0 0 0 2.94-1.66 3 3 0 0 0-.05-3.04zM12 17a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm1-4a1 1 0 0 1-2 0V9a1 1 0 0 1 2 0z" />
      </g>
    </g>
  </svg>
);

export const AlertCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="alert-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <circle cx="12" cy="16" r="1" />
        <path d="M12 7a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

export const AlertCircleFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="alert-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 15a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm1-4a1 1 0 0 1-2 0V8a1 1 0 0 1 2 0z" />
      </g>
    </g>
  </svg>
);

//B

export const BarChart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="bar-chart">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M12 4a1 1 0 0 0-1 1v15a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1z" />
        <path d="M19 12a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0v-7a1 1 0 0 0-1-1z" />
        <path d="M5 8a1 1 0 0 0-1 1v11a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

export const BlockJSON = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 18.4999C21.5523 18.4999 22 18.9477 22 19.4999C22 20.0522 21.5523 20.4999 21 20.4999H3C2.44772 20.4999 2 20.0522 2 19.4999C2 18.9477 2.44772 18.4999 3 18.4999H21Z"
      fill="currentColor"
    />
    <path
      d="M5 3.49994C5.55228 3.49994 5.99999 3.94766 6 4.49994C6 5.05222 5.55228 5.49994 5 5.49994V7.49994C5 7.85448 4.90393 8.19822 4.72949 8.49994C4.90393 8.80165 5 9.1454 5 9.49994V11.4999C5.55228 11.4999 5.99999 11.9477 6 12.4999C6 13.0522 5.55228 13.4999 5 13.4999C4.46957 13.4999 3.96101 13.2891 3.58594 12.914C3.21087 12.5389 3 12.0304 3 11.4999V9.49994C2.44772 9.49994 2 9.05222 2 8.49994C2.00001 7.94766 2.44772 7.49994 3 7.49994V5.49994C3.00001 4.96951 3.21087 4.46094 3.58594 4.08588C3.96101 3.71081 4.46957 3.49994 5 3.49994Z"
      fill="currentColor"
    />
    <path
      d="M9 3.49994C9.53043 3.49994 10.039 3.71081 10.4141 4.08588C10.7891 4.46094 11 4.96951 11 5.49994V7.49994C11.5523 7.49994 12 7.94766 12 8.49994C12 9.05222 11.5523 9.49994 11 9.49994V11.4999C11 12.0304 10.7891 12.5389 10.4141 12.914C10.039 13.2891 9.53043 13.4999 9 13.4999C8.44772 13.4999 8 13.0522 8 12.4999C8.00001 11.9477 8.44772 11.4999 9 11.4999V9.49994C9 9.14556 9.09525 8.80155 9.26953 8.49994C9.09525 8.19833 9 7.85432 9 7.49994V5.49994C8.44772 5.49994 8 5.05222 8 4.49994C8.00001 3.94766 8.44772 3.49994 9 3.49994Z"
      fill="currentColor"
    />
    <path
      d="M21 11.4999C21.5523 11.4999 22 11.9477 22 12.4999C22 13.0522 21.5523 13.4999 21 13.4999H15C14.4477 13.4999 14 13.0522 14 12.4999C14 11.9477 14.4477 11.4999 15 11.4999H21Z"
      fill="currentColor"
    />
    <path
      d="M21 4.49994C21.5523 4.49994 22 4.94765 22 5.49994C22 6.05222 21.5523 6.49994 21 6.49994H15C14.4477 6.49994 14 6.05222 14 5.49994C14 4.94765 14.4477 4.49994 15 4.49994H21Z"
      fill="currentColor"
    />
  </svg>
);

export const BlockString = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 18.4999C21.5523 18.4999 22 18.9477 22 19.4999C22 20.0522 21.5523 20.4999 21 20.4999H3C2.44772 20.4999 2 20.0522 2 19.4999C2 18.9477 2.44772 18.4999 3 18.4999H21Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 3.49994C7.20885 3.49994 7.41472 3.54334 7.60449 3.62689L7.78809 3.72357L7.95703 3.84467C8.11657 3.97683 8.24732 4.14151 8.34082 4.32806C8.3458 4.33799 8.35083 4.34825 8.35547 4.35834L11.9082 12.082C12.139 12.5837 11.9196 13.1773 11.418 13.4081C10.9163 13.6389 10.3227 13.4195 10.0918 12.9179L9.43945 11.4999H4.56055L3.9082 12.9179C3.67734 13.4195 3.08371 13.6389 2.58203 13.4081C2.0804 13.1773 1.86102 12.5837 2.0918 12.082L2.99512 10.1171C2.99897 10.1078 3.00369 10.0989 3.00781 10.0898L5.64453 4.35834L5.65918 4.32806C5.78388 4.07927 5.97512 3.86978 6.21191 3.72357L6.39551 3.62689C6.58528 3.54334 6.79115 3.49994 7 3.49994ZM5.48047 9.49994H8.51953L7 6.19818L5.48047 9.49994Z"
      fill="currentColor"
    />
    <path
      d="M21 11.4999C21.5523 11.4999 22 11.9477 22 12.4999C22 13.0522 21.5523 13.4999 21 13.4999H15C14.4477 13.4999 14 13.0522 14 12.4999C14 11.9477 14.4477 11.4999 15 11.4999H21Z"
      fill="currentColor"
    />
    <path
      d="M21 4.49994C21.5523 4.49994 22 4.94765 22 5.49994C22 6.05222 21.5523 6.49994 21 6.49994H15C14.4477 6.49994 14 6.05222 14 5.49994C14 4.94765 14.4477 4.49994 15 4.49994H21Z"
      fill="currentColor"
    />
  </svg>
);

export const BookFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="book">
        <rect width="24" height="24" opacity="0" />
        <path d="M19 3H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM7 19a1 1 0 0 1 0-2h11v2z" />
      </g>
    </g>
  </svg>
);

export const Book = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="book">
        <rect width="24" height="24" opacity="0" />
        <path d="M19 3H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM7 5h11v10H7a3 3 0 0 0-1 .18V6a1 1 0 0 1 1-1zm0 14a1 1 0 0 1 0-2h11v2z" />
      </g>
    </g>
  </svg>
);

// @src: lucide
export const BookmarkCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{ fill: "none", stroke: "currentColor" }}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z" />
    <path d="m9 10 2 2 4-4" />
  </svg>
);

// @src: lucide
export const BookmarkX = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{ fill: "none", stroke: "currentColor" }}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m14.5 7.5-5 5" />
    <path d="M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z" />
    <path d="m9.5 7.5 5 5" />
  </svg>
);

export const Bulb = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="bulb">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 7a5 5 0 0 0-3 9v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a5 5 0 0 0-3-9zm1.5 7.59a1 1 0 0 0-.5.87V20h-2v-4.54a1 1 0 0 0-.5-.87A3 3 0 0 1 9 12a3 3 0 0 1 6 0 3 3 0 0 1-1.5 2.59z" />
        <path d="M12 6a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1z" />
        <path d="M21 11h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z" />
        <path d="M5 11H3a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z" />
        <path d="M7.66 6.42L6.22 5a1 1 0 0 0-1.39 1.47l1.44 1.39a1 1 0 0 0 .73.28 1 1 0 0 0 .72-.31 1 1 0 0 0-.06-1.41z" />
        <path d="M19.19 5.05a1 1 0 0 0-1.41 0l-1.44 1.37a1 1 0 0 0 0 1.41 1 1 0 0 0 .72.31 1 1 0 0 0 .69-.28l1.44-1.39a1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

//C
export const Calendar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="calendar">
        <rect width="24" height="24" opacity="0" />
        <path d="M18 4h-1V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zM6 6h1v1a1 1 0 0 0 2 0V6h6v1a1 1 0 0 0 2 0V6h1a1 1 0 0 1 1 1v4H5V7a1 1 0 0 1 1-1zm12 14H6a1 1 0 0 1-1-1v-6h14v6a1 1 0 0 1-1 1z" />
        <circle cx="8" cy="16" r="1" />
        <path d="M16 15h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

// @src: lucide chart-bar-decreasing
export const ChartBarDecreasing = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path fill="none" d="M3 3v16a2 2 0 0 0 2 2h16" />
    <path fill="none" d="M7 11h8" />
    <path fill="none" d="M7 16h3" />
    <path fill="none" d="M7 6h12" />
  </svg>
);

// @src: lucide chart-no-axes-column
export const ChartNoAxesColumn = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path fill="none" d="M5 21v-6" />
    <path fill="none" d="M12 21V3" />
    <path fill="none" d="M19 21V9" />
  </svg>
);

// @src: lucide chart-line
export const ChartLine = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path fill="none" d="M3 3v16a2 2 0 0 0 2 2h16" />
    <path fill="none" d="m19 9-5 5-4-4-3 3" />
  </svg>
);

// @src: lucide message-circle-dashed; flattened with flatten-icon
export const ChatEphemeralityOff = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.91 1.20022Q12 0.795748 14.09 1.20022Q14.2853 1.23801 14.4512 1.34766Q14.6172 1.45731 14.7286 1.62212Q14.8399 1.78694 14.8798 1.98182Q14.9196 2.17671 14.8818 2.372Q14.8631 2.4687 14.8258 2.55989Q14.7886 2.65107 14.7343 2.73325Q14.68 2.81542 14.6108 2.88543Q14.5415 2.95543 14.4599 3.01058Q14.3783 3.06572 14.2875 3.10388Q14.1967 3.14204 14.1002 3.16176Q14.0037 3.18148 13.9052 3.18199Q13.8067 3.1825 13.71 3.16378Q12 2.83286 10.29 3.16378Q10.0947 3.20158 9.89982 3.16176Q9.70494 3.12194 9.54012 3.01058Q9.37531 2.89921 9.26566 2.73325Q9.15601 2.56729 9.11822 2.372Q9.0995 2.2753 9.10001 2.17681Q9.10052 2.07832 9.12024 1.98182Q9.13995 1.88533 9.17812 1.79453Q9.21628 1.70373 9.27142 1.62212Q9.32657 1.54052 9.39657 1.47123Q9.46657 1.40195 9.54875 1.34766Q9.63092 1.29337 9.72211 1.25615Q9.8133 1.21893 9.91 1.20022ZM2.89314 5.83006Q4.09093 4.06229 5.86314 2.87106Q5.94488 2.81612 6.03577 2.77818Q6.12666 2.74024 6.22321 2.72076Q6.31975 2.70127 6.41824 2.701Q6.51674 2.70073 6.61339 2.71968Q6.71004 2.73863 6.80114 2.77607Q6.89223 2.81351 6.97428 2.868Q7.05632 2.92249 7.12615 2.99195Q7.19599 3.0614 7.25094 3.14314Q7.30588 3.22488 7.34382 3.31577Q7.38176 3.40666 7.40124 3.50321Q7.42072 3.59975 7.421 3.69824Q7.42127 3.79673 7.40232 3.89339Q7.38337 3.99004 7.34593 4.08114Q7.30849 4.17223 7.254 4.25428Q7.1995 4.33632 7.13005 4.40615Q7.0606 4.47599 6.97886 4.53094Q5.52887 5.50558 4.54886 6.95193Q4.43728 7.11661 4.27118 7.22604Q4.10508 7.33548 3.90974 7.37303Q3.71441 7.41057 3.51957 7.3705Q3.32474 7.33044 3.16006 7.21886Q3.07853 7.16361 3.00934 7.09352Q2.94014 7.02343 2.88596 6.94118Q2.83177 6.85894 2.79466 6.7677Q2.75756 6.67646 2.73897 6.57974Q2.72038 6.48302 2.72102 6.38453Q2.72166 6.28604 2.7415 6.18957Q2.76134 6.0931 2.79961 6.00235Q2.83789 5.9116 2.89314 5.83006ZM18.1699 2.89214Q19.9377 4.08994 21.1289 5.86214Q21.1839 5.94388 21.2218 6.03477Q21.2598 6.12566 21.2792 6.22221Q21.2987 6.31875 21.299 6.41724Q21.2993 6.51573 21.2803 6.61239Q21.2614 6.70904 21.2239 6.80014Q21.1865 6.89123 21.132 6.97328Q21.0775 7.05532 21.0081 7.12515Q20.9386 7.19499 20.8569 7.24994Q20.6918 7.3609 20.4968 7.40024Q20.3018 7.43959 20.1066 7.40132Q19.9114 7.36305 19.7457 7.253Q19.58 7.14294 19.4691 6.97786Q18.4944 5.52788 17.0481 4.54786Q16.8834 4.43628 16.774 4.27018Q16.6645 4.10408 16.627 3.90874Q16.5894 3.71341 16.6295 3.51857Q16.6696 3.32374 16.7811 3.15906Q16.8364 3.07753 16.9065 3.00834Q16.9766 2.93914 17.0588 2.88495Q17.1411 2.83077 17.2323 2.79366Q17.3235 2.75656 17.4203 2.73797Q17.517 2.71938 17.6155 2.72002Q17.714 2.72066 17.8104 2.7405Q17.9069 2.76034 17.9976 2.79861Q18.0884 2.83689 18.1699 2.89214ZM1.20022 14.09Q0.795748 12 1.20022 9.91Q1.23801 9.71471 1.34766 9.54875Q1.45731 9.38279 1.62212 9.27142Q1.78694 9.16006 1.98182 9.12024Q2.17671 9.08042 2.372 9.11822Q2.4687 9.13693 2.55989 9.17415Q2.65107 9.21137 2.73325 9.26566Q2.81542 9.31995 2.88543 9.38923Q2.95543 9.45852 3.01058 9.54012Q3.06572 9.62173 3.10388 9.71253Q3.14204 9.80333 3.16176 9.89982Q3.18148 9.99632 3.18199 10.0948Q3.1825 10.1933 3.16378 10.29Q2.83286 12 3.16378 13.71Q3.20158 13.9053 3.16176 14.1002Q3.12194 14.2951 3.01058 14.4599Q2.89921 14.6247 2.73325 14.7343Q2.56729 14.844 2.372 14.8818Q2.2753 14.9005 2.17681 14.9Q2.07832 14.8995 1.98182 14.8798Q1.88533 14.86 1.79453 14.8219Q1.70373 14.7837 1.62212 14.7286Q1.54052 14.6734 1.47123 14.6034Q1.40195 14.5334 1.34766 14.4512Q1.29337 14.3691 1.25615 14.2779Q1.21893 14.1867 1.20022 14.09ZM22.7998 9.91Q23.2043 12 22.7998 14.09Q22.7811 14.1867 22.7439 14.2779Q22.7066 14.3691 22.6523 14.4512Q22.598 14.5334 22.5288 14.6034Q22.4595 14.6734 22.3779 14.7286Q22.2963 14.7837 22.2055 14.8219Q22.1147 14.86 22.0182 14.8798Q21.9217 14.8995 21.8232 14.9Q21.7247 14.9005 21.628 14.8818Q21.4327 14.844 21.2667 14.7343Q21.1008 14.6247 20.9894 14.4599Q20.8781 14.2951 20.8382 14.1002Q20.7984 13.9053 20.8362 13.71Q21.1671 12 20.8362 10.29Q20.7984 10.0947 20.8382 9.89983Q20.8781 9.70494 20.9894 9.54012Q21.1008 9.37531 21.2667 9.26566Q21.4327 9.15601 21.628 9.11822Q21.7247 9.0995 21.8232 9.10001Q21.9217 9.10052 22.0182 9.12024Q22.1147 9.13995 22.2055 9.17812Q22.2963 9.21628 22.3779 9.27142Q22.4595 9.32657 22.5288 9.39657Q22.598 9.46657 22.6523 9.54875Q22.7066 9.63092 22.7439 9.72211Q22.7811 9.8133 22.7998 9.91ZM21.1079 18.1709Q19.9101 19.9387 18.1379 21.1299Q18.0561 21.1849 17.9652 21.2228Q17.8743 21.2608 17.7778 21.2802Q17.6812 21.2997 17.5828 21.3Q17.4843 21.3003 17.3876 21.2813Q17.291 21.2624 17.1999 21.2249Q17.1088 21.1875 17.0267 21.133Q16.9447 21.0785 16.8748 21.0091Q16.805 20.9396 16.7501 20.8579Q16.6951 20.7761 16.6572 20.6852Q16.6192 20.5943 16.5998 20.4978Q16.5803 20.4012 16.58 20.3028Q16.5797 20.2043 16.5987 20.1076Q16.6176 20.011 16.6551 19.9199Q16.6925 19.8288 16.747 19.7467Q16.8015 19.6647 16.8709 19.5948Q16.9404 19.525 17.0221 19.4701Q18.4721 18.4954 19.4521 17.0491Q19.5074 16.9675 19.5775 16.8983Q19.6476 16.8291 19.7298 16.775Q19.8121 16.7208 19.9033 16.6837Q19.9945 16.6466 20.0913 16.628Q20.188 16.6094 20.2865 16.61Q20.385 16.6107 20.4814 16.6305Q20.5779 16.6503 20.6686 16.6886Q20.7594 16.7269 20.8409 16.7821Q20.9225 16.8374 20.9917 16.9075Q21.0609 16.9776 21.115 17.0598Q21.1692 17.1421 21.2063 17.2333Q21.2434 17.3245 21.262 17.4213Q21.2806 17.518 21.28 17.6165Q21.2793 17.715 21.2595 17.8114Q21.2397 17.9079 21.2014 17.9986Q21.1631 18.0894 21.1079 18.1709ZM6.44374 22.0768L3.53774 22.9268Q3.52577 22.9303 3.51372 22.9335Q2.43608 23.2197 1.626 22.4536Q0.815914 21.6874 1.04172 20.5955Q1.05279 20.5419 1.06964 20.4899L2.03464 17.5099Q2.06498 17.4162 2.11302 17.3302Q2.16106 17.2443 2.22495 17.1693Q2.28884 17.0943 2.36613 17.0333Q2.44342 16.9722 2.53113 16.9274Q2.61884 16.8826 2.71361 16.8558Q2.80837 16.829 2.90655 16.8212Q3.00473 16.8133 3.10255 16.8248Q3.20037 16.8363 3.29408 16.8666Q3.48331 16.9279 3.63469 17.057Q3.78608 17.186 3.87656 17.3631Q3.96704 17.5403 3.98284 17.7386Q3.99864 17.9368 3.93736 18.1261L3.00732 20.9981L5.88226 20.1572Q5.97679 20.1296 6.0749 20.1209Q6.17301 20.1122 6.27093 20.1228Q6.36884 20.1335 6.4628 20.163Q6.55677 20.1925 6.64316 20.2398Q6.72955 20.2871 6.80506 20.3503Q6.88057 20.4136 6.94229 20.4903Q7.00401 20.5671 7.04957 20.6544Q7.09513 20.7417 7.12279 20.8363Q7.17863 21.0272 7.15716 21.2249Q7.13569 21.4227 7.04018 21.5972Q6.94467 21.7716 6.78966 21.8963Q6.63465 22.0209 6.44374 22.0768ZM14.09 22.7998Q12 23.2043 9.91 22.7998Q9.8133 22.7811 9.72211 22.7439Q9.63092 22.7066 9.54875 22.6523Q9.46657 22.598 9.39657 22.5288Q9.32656 22.4595 9.27142 22.3779Q9.21628 22.2963 9.17812 22.2055Q9.13995 22.1147 9.12024 22.0182Q9.10052 21.9217 9.10001 21.8232Q9.0995 21.7247 9.11822 21.628Q9.15601 21.4327 9.26566 21.2667Q9.37531 21.1008 9.54012 20.9894Q9.70494 20.8781 9.89983 20.8382Q10.0947 20.7984 10.29 20.8362Q12 21.1671 13.71 20.8362Q13.9053 20.7984 14.1002 20.8382Q14.2951 20.8781 14.4599 20.9894Q14.6247 21.1008 14.7343 21.2667Q14.844 21.4327 14.8818 21.628Q14.9005 21.7247 14.9 21.8232Q14.8995 21.9217 14.8798 22.0182Q14.86 22.1147 14.8219 22.2055Q14.7837 22.2963 14.7286 22.3779Q14.6734 22.4595 14.6034 22.5288Q14.5334 22.598 14.4512 22.6523Q14.3691 22.7066 14.2779 22.7439Q14.1867 22.7811 14.09 22.7998Z"
      fill="currentColor"
    />
  </svg>
);

// @src: lucide message-circle-dashed + message-circle-check glyph; flattened with flatten-icon
export const ChatEphemeralityOn = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.91 1.20022Q12 0.795748 14.09 1.20022Q14.2853 1.23801 14.4512 1.34766Q14.6172 1.45731 14.7286 1.62212Q14.8399 1.78694 14.8798 1.98182Q14.9196 2.17671 14.8818 2.372Q14.8631 2.4687 14.8258 2.55989Q14.7886 2.65107 14.7343 2.73325Q14.68 2.81542 14.6108 2.88543Q14.5415 2.95543 14.4599 3.01058Q14.3783 3.06572 14.2875 3.10388Q14.1967 3.14204 14.1002 3.16176Q14.0037 3.18148 13.9052 3.18199Q13.8067 3.1825 13.71 3.16378Q12 2.83286 10.29 3.16378Q10.0947 3.20158 9.89982 3.16176Q9.70494 3.12194 9.54012 3.01058Q9.37531 2.89921 9.26566 2.73325Q9.15601 2.56729 9.11822 2.372Q9.0995 2.2753 9.10001 2.17681Q9.10052 2.07832 9.12024 1.98182Q9.13995 1.88533 9.17812 1.79453Q9.21628 1.70373 9.27142 1.62212Q9.32657 1.54052 9.39657 1.47123Q9.46657 1.40195 9.54875 1.34766Q9.63092 1.29337 9.72211 1.25615Q9.8133 1.21893 9.91 1.20022ZM2.89314 5.83006Q4.09093 4.06229 5.86314 2.87106Q5.94488 2.81612 6.03577 2.77818Q6.12666 2.74024 6.22321 2.72076Q6.31975 2.70127 6.41824 2.701Q6.51674 2.70073 6.61339 2.71968Q6.71004 2.73863 6.80114 2.77607Q6.89223 2.81351 6.97428 2.868Q7.05632 2.92249 7.12615 2.99195Q7.19599 3.0614 7.25094 3.14314Q7.30588 3.22488 7.34382 3.31577Q7.38176 3.40666 7.40124 3.50321Q7.42072 3.59975 7.421 3.69824Q7.42127 3.79673 7.40232 3.89339Q7.38337 3.99004 7.34593 4.08114Q7.30849 4.17223 7.254 4.25428Q7.1995 4.33632 7.13005 4.40615Q7.0606 4.47599 6.97886 4.53094Q5.52887 5.50558 4.54886 6.95193Q4.43728 7.11661 4.27118 7.22604Q4.10508 7.33548 3.90974 7.37303Q3.71441 7.41057 3.51957 7.3705Q3.32474 7.33044 3.16006 7.21886Q3.07853 7.16361 3.00934 7.09352Q2.94014 7.02343 2.88596 6.94118Q2.83177 6.85894 2.79466 6.7677Q2.75756 6.67646 2.73897 6.57974Q2.72038 6.48302 2.72102 6.38453Q2.72166 6.28604 2.7415 6.18957Q2.76134 6.0931 2.79961 6.00235Q2.83789 5.9116 2.89314 5.83006ZM18.1699 2.89214Q19.9377 4.08994 21.1289 5.86214Q21.1839 5.94388 21.2218 6.03477Q21.2598 6.12566 21.2792 6.22221Q21.2987 6.31875 21.299 6.41724Q21.2993 6.51573 21.2803 6.61239Q21.2614 6.70904 21.2239 6.80014Q21.1865 6.89123 21.132 6.97328Q21.0775 7.05532 21.0081 7.12515Q20.9386 7.19499 20.8569 7.24994Q20.6918 7.3609 20.4968 7.40024Q20.3018 7.43959 20.1066 7.40132Q19.9114 7.36305 19.7457 7.253Q19.58 7.14294 19.4691 6.97786Q18.4944 5.52788 17.0481 4.54786Q16.8834 4.43628 16.774 4.27018Q16.6645 4.10408 16.627 3.90874Q16.5894 3.71341 16.6295 3.51857Q16.6696 3.32374 16.7811 3.15906Q16.8364 3.07753 16.9065 3.00834Q16.9766 2.93914 17.0588 2.88495Q17.1411 2.83077 17.2323 2.79366Q17.3235 2.75656 17.4203 2.73797Q17.517 2.71938 17.6155 2.72002Q17.714 2.72066 17.8104 2.7405Q17.9069 2.76034 17.9976 2.79861Q18.0884 2.83689 18.1699 2.89214ZM9.70711 11.2929L11 12.5858L14.2929 9.29289Q14.3625 9.22325 14.4444 9.16853Q14.5263 9.11381 14.6173 9.07612Q14.7083 9.03843 14.8049 9.01921Q14.9015 9 15 9Q15.0985 9 15.1951 9.01921Q15.2917 9.03843 15.3827 9.07612Q15.4737 9.11381 15.5556 9.16853Q15.6375 9.22325 15.7071 9.29289Q15.7767 9.36254 15.8315 9.44443Q15.8862 9.52632 15.9239 9.61732Q15.9616 9.70831 15.9808 9.80491Q16 9.90151 16 10Q16 10.0985 15.9808 10.1951Q15.9616 10.2917 15.9239 10.3827Q15.8862 10.4737 15.8315 10.5556Q15.7767 10.6375 15.7071 10.7071L11.7071 14.7071Q11.6375 14.7767 11.5556 14.8315Q11.4737 14.8862 11.3827 14.9239Q11.2917 14.9616 11.1951 14.9808Q11.0985 15 11 15Q10.9015 15 10.8049 14.9808Q10.7083 14.9616 10.6173 14.9239Q10.5263 14.8862 10.4444 14.8315Q10.3625 14.7767 10.2929 14.7071L8.29289 12.7071Q8.22325 12.6375 8.16853 12.5556Q8.11381 12.4737 8.07612 12.3827Q8.03843 12.2917 8.01921 12.1951Q8 12.0985 8 12Q8 11.9015 8.01921 11.8049Q8.03843 11.7083 8.07612 11.6173Q8.11381 11.5263 8.16853 11.4444Q8.22325 11.3625 8.29289 11.2929Q8.36254 11.2232 8.44443 11.1685Q8.52632 11.1138 8.61732 11.0761Q8.70831 11.0384 8.80491 11.0192Q8.90151 11 9 11Q9.09849 11 9.19509 11.0192Q9.29169 11.0384 9.38268 11.0761Q9.47368 11.1138 9.55557 11.1685Q9.63746 11.2232 9.70711 11.2929ZM1.20022 14.09Q0.795748 12 1.20022 9.91Q1.23801 9.71471 1.34766 9.54875Q1.45731 9.38279 1.62212 9.27142Q1.78694 9.16006 1.98182 9.12024Q2.17671 9.08042 2.372 9.11822Q2.4687 9.13693 2.55989 9.17415Q2.65107 9.21137 2.73325 9.26566Q2.81542 9.31995 2.88543 9.38923Q2.95543 9.45852 3.01058 9.54012Q3.06572 9.62173 3.10388 9.71253Q3.14204 9.80333 3.16176 9.89982Q3.18148 9.99632 3.18199 10.0948Q3.1825 10.1933 3.16378 10.29Q2.83286 12 3.16378 13.71Q3.20158 13.9053 3.16176 14.1002Q3.12194 14.2951 3.01058 14.4599Q2.89921 14.6247 2.73325 14.7343Q2.56729 14.844 2.372 14.8818Q2.2753 14.9005 2.17681 14.9Q2.07832 14.8995 1.98182 14.8798Q1.88533 14.86 1.79453 14.8219Q1.70373 14.7837 1.62212 14.7286Q1.54052 14.6734 1.47123 14.6034Q1.40195 14.5334 1.34766 14.4512Q1.29337 14.3691 1.25615 14.2779Q1.21893 14.1867 1.20022 14.09ZM22.7998 9.91Q23.2043 12 22.7998 14.09Q22.7811 14.1867 22.7439 14.2779Q22.7066 14.3691 22.6523 14.4512Q22.598 14.5334 22.5288 14.6034Q22.4595 14.6734 22.3779 14.7286Q22.2963 14.7837 22.2055 14.8219Q22.1147 14.86 22.0182 14.8798Q21.9217 14.8995 21.8232 14.9Q21.7247 14.9005 21.628 14.8818Q21.4327 14.844 21.2667 14.7343Q21.1008 14.6247 20.9894 14.4599Q20.8781 14.2951 20.8382 14.1002Q20.7984 13.9053 20.8362 13.71Q21.1671 12 20.8362 10.29Q20.7984 10.0947 20.8382 9.89983Q20.8781 9.70494 20.9894 9.54012Q21.1008 9.37531 21.2667 9.26566Q21.4327 9.15601 21.628 9.11822Q21.7247 9.0995 21.8232 9.10001Q21.9217 9.10052 22.0182 9.12024Q22.1147 9.13995 22.2055 9.17812Q22.2963 9.21628 22.3779 9.27142Q22.4595 9.32657 22.5288 9.39657Q22.598 9.46657 22.6523 9.54875Q22.7066 9.63092 22.7439 9.72211Q22.7811 9.8133 22.7998 9.91ZM21.1079 18.1709Q19.9101 19.9387 18.1379 21.1299Q18.0561 21.1849 17.9652 21.2228Q17.8743 21.2608 17.7778 21.2802Q17.6812 21.2997 17.5828 21.3Q17.4843 21.3003 17.3876 21.2813Q17.291 21.2624 17.1999 21.2249Q17.1088 21.1875 17.0267 21.133Q16.9447 21.0785 16.8748 21.0091Q16.805 20.9396 16.7501 20.8579Q16.6951 20.7761 16.6572 20.6852Q16.6192 20.5943 16.5998 20.4978Q16.5803 20.4012 16.58 20.3028Q16.5797 20.2043 16.5987 20.1076Q16.6176 20.011 16.6551 19.9199Q16.6925 19.8288 16.747 19.7467Q16.8015 19.6647 16.8709 19.5948Q16.9404 19.525 17.0221 19.4701Q18.4721 18.4954 19.4521 17.0491Q19.5074 16.9675 19.5775 16.8983Q19.6476 16.8291 19.7298 16.775Q19.8121 16.7208 19.9033 16.6837Q19.9945 16.6466 20.0913 16.628Q20.188 16.6094 20.2865 16.61Q20.385 16.6107 20.4814 16.6305Q20.5779 16.6503 20.6686 16.6886Q20.7594 16.7269 20.8409 16.7821Q20.9225 16.8374 20.9917 16.9075Q21.0609 16.9776 21.115 17.0598Q21.1692 17.1421 21.2063 17.2333Q21.2434 17.3245 21.262 17.4213Q21.2806 17.518 21.28 17.6165Q21.2793 17.715 21.2595 17.8114Q21.2397 17.9079 21.2014 17.9986Q21.1631 18.0894 21.1079 18.1709ZM6.44374 22.0768L3.53774 22.9268Q3.52577 22.9303 3.51372 22.9335Q2.43608 23.2197 1.626 22.4536Q0.815914 21.6874 1.04172 20.5955Q1.05279 20.5419 1.06964 20.4899L2.03464 17.5099Q2.06498 17.4162 2.11302 17.3302Q2.16106 17.2443 2.22495 17.1693Q2.28884 17.0943 2.36613 17.0333Q2.44342 16.9722 2.53113 16.9274Q2.61884 16.8826 2.71361 16.8558Q2.80837 16.829 2.90655 16.8212Q3.00473 16.8133 3.10255 16.8248Q3.20037 16.8363 3.29408 16.8666Q3.48331 16.9279 3.63469 17.057Q3.78608 17.186 3.87656 17.3631Q3.96704 17.5403 3.98284 17.7386Q3.99864 17.9368 3.93736 18.1261L3.00732 20.9981L5.88226 20.1572Q5.97679 20.1296 6.0749 20.1209Q6.17301 20.1122 6.27093 20.1228Q6.36884 20.1335 6.4628 20.163Q6.55677 20.1925 6.64316 20.2398Q6.72955 20.2871 6.80506 20.3503Q6.88057 20.4136 6.94229 20.4903Q7.00401 20.5671 7.04957 20.6544Q7.09513 20.7417 7.12279 20.8363Q7.17863 21.0272 7.15716 21.2249Q7.13569 21.4227 7.04018 21.5972Q6.94467 21.7716 6.78966 21.8963Q6.63465 22.0209 6.44374 22.0768ZM14.09 22.7998Q12 23.2043 9.91 22.7998Q9.8133 22.7811 9.72211 22.7439Q9.63092 22.7066 9.54875 22.6523Q9.46657 22.598 9.39657 22.5288Q9.32656 22.4595 9.27142 22.3779Q9.21628 22.2963 9.17812 22.2055Q9.13995 22.1147 9.12024 22.0182Q9.10052 21.9217 9.10001 21.8232Q9.0995 21.7247 9.11822 21.628Q9.15601 21.4327 9.26566 21.2667Q9.37531 21.1008 9.54012 20.9894Q9.70494 20.8781 9.89983 20.8382Q10.0947 20.7984 10.29 20.8362Q12 21.1671 13.71 20.8362Q13.9053 20.7984 14.1002 20.8382Q14.2951 20.8781 14.4599 20.9894Q14.6247 21.1008 14.7343 21.2667Q14.844 21.4327 14.8818 21.628Q14.9005 21.7247 14.9 21.8232Q14.8995 21.9217 14.8798 22.0182Q14.86 22.1147 14.8219 22.2055Q14.7837 22.2963 14.7286 22.3779Q14.6734 22.4595 14.6034 22.5288Q14.5334 22.598 14.4512 22.6523Q14.3691 22.7066 14.2779 22.7439Q14.1867 22.7811 14.09 22.7998Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronUpDownSmall = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 18 18"
    width="24"
  >
    <path
      className="fill"
      d="M14,5.99a1,1,0,0,1-1.7055.7055L9.006,3.409,5.717,6.695A1,1,0,0,1,4.28,5.3085l.0245-.0245L8.3,1.2925a1,1,0,0,1,1.4125,0L13.707,5.284A.99446.99446,0,0,1,14,5.99Z"
    />
    <path
      className="fill"
      d="M4,12.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,16.707a1,1,0,0,1-1.4125,0L4.293,12.7155A.99452.99452,0,0,1,4,12.01Z"
    />
  </svg>
);

export const Column = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.2 12.4H9.8C10.0889 12.4 10.375 12.3431 10.6419 12.2325C10.9088 12.122 11.1513 11.9599 11.3556 11.7556C11.5599 11.5513 11.722 11.3088 11.8325 11.0419C11.9431 10.775 12 10.4889 12 10.2V2.2C12 1.91109 11.9431 1.62501 11.8325 1.3581C11.722 1.09118 11.5599 0.848654 11.3556 0.644365C11.1513 0.440076 10.9088 0.278026 10.6419 0.167465C10.375 0.0569049 10.0889 0 9.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V10.2C0 10.7835 0.231785 11.3431 0.644365 11.7556C1.05694 12.1682 1.61652 12.4 2.2 12.4ZM4.8 11.2V1.2H7.2V11.2H4.8ZM10.8 2.2V10.2C10.8 10.4652 10.6946 10.7196 10.5071 10.9071C10.3196 11.0946 10.0652 11.2 9.8 11.2H8.4V1.2H9.8C10.0652 1.2 10.3196 1.30536 10.5071 1.49289C10.6946 1.68043 10.8 1.93478 10.8 2.2ZM1.2 2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H3.6V11.2H2.2C1.93478 11.2 1.68043 11.0946 1.49289 10.9071C1.30536 10.7196 1.2 10.4652 1.2 10.2V2.2Z" />
  </svg>
);

export const ArrowUpRightCorner = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="corner-up-right">
        <rect
          width="24"
          height="24"
          transform="rotate(-90 12 12)"
          opacity="0"
        />
        <path d="M19.78 10.38l-4-5a1 1 0 0 0-1.56 1.24l2.7 3.38H8a3 3 0 0 0-3 3v5a1 1 0 0 0 2 0v-5a1 1 0 0 1 1-1h8.92l-2.7 3.38a1 1 0 0 0 .16 1.4A1 1 0 0 0 15 17a1 1 0 0 0 .78-.38l4-5a1 1 0 0 0 0-1.24z" />
      </g>
    </g>
  </svg>
);

// @src: lucide
export const CircleUserRound = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path fill="none" d="M17.925 20.056a6 6 0 0 0-11.851.001" />
    <circle fill="none" cx="12" cy="11" r="4" />
    <circle fill="none" cx="12" cy="12" r="10" />
  </svg>
);

export const Code = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="code">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M8.64 5.23a1 1 0 0 0-1.41.13l-5 6a1 1 0 0 0 0 1.27l4.83 6a1 1 0 0 0 .78.37 1 1 0 0 0 .78-1.63L4.29 12l4.48-5.36a1 1 0 0 0-.13-1.41z" />
        <path d="M21.78 11.37l-4.78-6a1 1 0 0 0-1.41-.15 1 1 0 0 0-.15 1.41L19.71 12l-4.48 5.37a1 1 0 0 0 .13 1.41A1 1 0 0 0 16 19a1 1 0 0 0 .77-.36l5-6a1 1 0 0 0 .01-1.27z" />
      </g>
    </g>
  </svg>
);

export const Console = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.29289 16.2929L8.58579 11L3.29289 5.70711Q3.15224 5.56645 3.07612 5.38268Q3 5.19891 3 5Q3 4.80109 3.07612 4.61732Q3.15224 4.43355 3.29289 4.29289Q3.43355 4.15224 3.61732 4.07612Q3.80109 4 4 4Q4.19891 4 4.38268 4.07612Q4.56645 4.15224 4.70711 4.29289L10.7071 10.2929Q10.7767 10.3625 10.8315 10.4444Q10.8862 10.5263 10.9239 10.6173Q10.9616 10.7083 10.9808 10.8049Q11 10.9015 11 11Q11 11.0985 10.9808 11.1951Q10.9616 11.2917 10.9239 11.3827Q10.8862 11.4737 10.8315 11.5556Q10.7767 11.6375 10.7071 11.7071L4.70711 17.7071Q4.56645 17.8478 4.38268 17.9239Q4.19891 18 4 18Q3.80109 18 3.61732 17.9239Q3.43355 17.8478 3.29289 17.7071Q3.22325 17.6375 3.16853 17.5556Q3.11381 17.4737 3.07612 17.3827Q3.03843 17.2917 3.01921 17.1951Q3 17.0985 3 17Q3 16.9015 3.01921 16.8049Q3.03843 16.7083 3.07612 16.6173Q3.11381 16.5263 3.16853 16.4444Q3.22325 16.3625 3.29289 16.2929ZM12 18L20 18Q20.0985 18 20.1951 18.0192Q20.2917 18.0384 20.3827 18.0761Q20.4737 18.1138 20.5556 18.1685Q20.6375 18.2232 20.7071 18.2929Q20.7767 18.3625 20.8315 18.4444Q20.8862 18.5263 20.9239 18.6173Q20.9616 18.7083 20.9808 18.8049Q21 18.9015 21 19Q21 19.0985 20.9808 19.1951Q20.9616 19.2917 20.9239 19.3827Q20.8862 19.4737 20.8315 19.5556Q20.7767 19.6375 20.7071 19.7071Q20.6375 19.7767 20.5556 19.8315Q20.4737 19.8862 20.3827 19.9239Q20.2917 19.9616 20.1951 19.9808Q20.0985 20 20 20L12 20Q11.9015 20 11.8049 19.9808Q11.7083 19.9616 11.6173 19.9239Q11.5263 19.8862 11.4444 19.8315Q11.3625 19.7767 11.2929 19.7071Q11.2232 19.6375 11.1685 19.5556Q11.1138 19.4737 11.0761 19.3827Q11.0384 19.2917 11.0192 19.1951Q11 19.0985 11 19Q11 18.9015 11.0192 18.8049Q11.0384 18.7083 11.0761 18.6173Q11.1138 18.5263 11.1685 18.4444Q11.2232 18.3625 11.2929 18.2929Q11.3625 18.2232 11.4444 18.1685Q11.5263 18.1138 11.6173 18.0761Q11.7083 18.0384 11.8049 18.0192Q11.9015 18 12 18Z"
    />
  </svg>
);

export const ChevronLeftSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="chevron-left">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M13.36 17a1 1 0 0 1-.72-.31l-3.86-4a1 1 0 0 1 0-1.4l4-4a1 1 0 1 1 1.42 1.42L10.9 12l3.18 3.3a1 1 0 0 1 0 1.41 1 1 0 0 1-.72.29z" />
      </g>
    </g>
  </svg>
);

export const ChevronRightSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="chevron-right">
        <rect
          width="24"
          height="24"
          transform="rotate(-90 12 12)"
          opacity="0"
        />
        <path d="M10.5 17a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42L13.1 12 9.92 8.69a1 1 0 0 1 0-1.41 1 1 0 0 1 1.42 0l3.86 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-.7.32z" />
      </g>
    </g>
  </svg>
);

export const ChevronUpSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="chevron-up">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M16 14.5a1 1 0 0 1-.71-.29L12 10.9l-3.3 3.18a1 1 0 0 1-1.41 0 1 1 0 0 1 0-1.42l4-3.86a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1 0 1.42 1 1 0 0 1-.69.28z" />
      </g>
    </g>
  </svg>
);

export const ChevronDownSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="chevron-down">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 15.5a1 1 0 0 1-.71-.29l-4-4a1 1 0 1 1 1.42-1.42L12 13.1l3.3-3.18a1 1 0 1 1 1.38 1.44l-4 3.86a1 1 0 0 1-.68.28z" />
      </g>
    </g>
  </svg>
);

export const Clock = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="clock">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M16 11h-3V8a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const Lock = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="lock">
        <rect width="24" height="24" opacity="0" />
        <path d="M17 8h-1V6.11a4 4 0 1 0-8 0V8H7a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3zm-7-1.89A2.06 2.06 0 0 1 12 4a2.06 2.06 0 0 1 2 2.11V8h-4zM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1z" />
        <path d="M12 12a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
      </g>
    </g>
  </svg>
);

export const Checkmark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="checkmark">
        <rect width="24" height="24" opacity="0" />
        <path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z" />
      </g>
    </g>
  </svg>
);

export const CheckmarkCircle = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.339 22.0001 6.836 20.9681 4.949 19.0911C3.055 17.2081 2.008 14.7001 2 12.0291C1.992 9.3571 3.025 6.8431 4.909 4.9491C6.792 3.0551 9.3 2.0081 11.971 2.0001C12.766 2.0121 13.576 2.0921 14.352 2.2781C14.888 2.4081 15.219 2.9481 15.089 3.4851C14.96 4.0211 14.417 4.3511 13.883 4.2231C13.262 4.0731 12.603 4.0101 11.977 4.0001C9.84 4.0061 7.833 4.8441 6.327 6.3591C4.82 7.8741 3.994 9.8861 4 12.0231C4.006 14.1601 4.844 16.1661 6.359 17.6731C7.869 19.1741 9.871 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.293 11.293C8.684 10.902 9.316 10.902 9.707 11.293L11.951 13.537L18.248 6.341C18.612 5.928 19.243 5.884 19.659 6.248C20.074 6.611 20.116 7.243 19.752 7.659L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.293 12.707C7.902 12.316 7.902 11.684 8.293 11.293Z"
      />
      <mask
        mask="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.339 22.0001 6.836 20.9681 4.949 19.0911C3.055 17.2081 2.008 14.7001 2 12.0291C1.992 9.3571 3.025 6.8431 4.909 4.9491C6.792 3.0551 9.3 2.0081 11.971 2.0001C12.766 2.0121 13.576 2.0921 14.352 2.2781C14.888 2.4081 15.219 2.9481 15.089 3.4851C14.96 4.0211 14.417 4.3511 13.883 4.2231C13.262 4.0731 12.603 4.0101 11.977 4.0001C9.84 4.0061 7.833 4.8441 6.327 6.3591C4.82 7.8741 3.994 9.8861 4 12.0231C4.006 14.1601 4.844 16.1661 6.359 17.6731C7.869 19.1741 9.871 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.293 11.293C8.684 10.902 9.316 10.902 9.707 11.293L11.951 13.537L18.248 6.341C18.612 5.928 19.243 5.884 19.659 6.248C20.074 6.611 20.116 7.243 19.752 7.659L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.293 12.707C7.902 12.316 7.902 11.684 8.293 11.293Z"
        />
      </mask>
      <g mask="url(#mask0)"></g>
    </g>
  </svg>
);

export const CheckmarkCircleFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="checkmark-circle-2">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm4.3 7.61l-4.57 6a1 1 0 0 1-.79.39 1 1 0 0 1-.79-.38l-2.44-3.11a1 1 0 0 1 1.58-1.23l1.63 2.08 3.78-5a1 1 0 1 1 1.6 1.22z" />
      </g>
    </g>
  </svg>
);

export const Close = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="close">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

export const CloseCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="close-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M14.71 9.29a1 1 0 0 0-1.42 0L12 10.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l1.3 1.29-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.29-1.3 1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 12l1.3-1.29a1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

export const Collapse = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="collapse">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M19 9h-2.58l3.29-3.29a1 1 0 1 0-1.42-1.42L15 7.57V5a1 1 0 0 0-1-1 1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2z" />
        <path d="M10 13H5a1 1 0 0 0 0 2h2.57l-3.28 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L9 16.42V19a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

export const CloudUpload = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="cloud-upload">
        <rect width="24" height="24" opacity="0" />
        <path d="M21.9 12c0-.11-.06-.22-.09-.33a4.17 4.17 0 0 0-.18-.57c-.05-.12-.12-.24-.18-.37s-.15-.3-.24-.44S21 10.08 21 10s-.2-.25-.31-.37-.21-.2-.32-.3L20 9l-.36-.24a3.68 3.68 0 0 0-.44-.23l-.39-.18a4.13 4.13 0 0 0-.5-.15 3 3 0 0 0-.41-.09L17.67 8A6 6 0 0 0 6.33 8l-.18.05a3 3 0 0 0-.41.09 4.13 4.13 0 0 0-.5.15l-.39.18a3.68 3.68 0 0 0-.44.23l-.36.3-.37.31c-.11.1-.22.19-.32.3s-.21.25-.31.37-.18.23-.26.36-.16.29-.24.44-.13.25-.18.37a4.17 4.17 0 0 0-.18.57c0 .11-.07.22-.09.33A5.23 5.23 0 0 0 2 13a5.5 5.5 0 0 0 .09.91c0 .1.05.19.07.29a5.58 5.58 0 0 0 .18.58l.12.29a5 5 0 0 0 .3.56l.14.22a.56.56 0 0 0 .05.08L3 16a5 5 0 0 0 4 2h3v-1.37a2 2 0 0 1-1 .27 2.05 2.05 0 0 1-1.44-.61 2 2 0 0 1 .05-2.83l3-2.9A2 2 0 0 1 12 10a2 2 0 0 1 1.41.59l3 3a2 2 0 0 1 0 2.82A2 2 0 0 1 15 17a1.92 1.92 0 0 1-1-.27V18h3a5 5 0 0 0 4-2l.05-.05a.56.56 0 0 0 .05-.08l.14-.22a5 5 0 0 0 .3-.56l.12-.29a5.58 5.58 0 0 0 .18-.58c0-.1.05-.19.07-.29A5.5 5.5 0 0 0 22 13a5.23 5.23 0 0 0-.1-1z" />
        <path d="M12.71 11.29a1 1 0 0 0-1.4 0l-3 2.9a1 1 0 1 0 1.38 1.44L11 14.36V20a1 1 0 0 0 2 0v-5.59l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

// @src: lucide box
export const Cube = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      fill="none"
      d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"
    />
    <path fill="none" d="m3.3 7 8.7 5 8.7-5" />
    <path fill="none" d="M12 22V12" />
  </svg>
);

//D
export const Database = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 6.16669L3.5 17.8334Q3.5 21.3334 12 21.3334Q15.2846 21.3334 17.6292 20.5507Q20.5 19.5923 20.5 17.8334L20.5 6.16669Q20.5 2.66669 12 2.66669Q3.5 2.66669 3.5 6.16669ZM16.9871 5.34761Q18.5 5.85192 18.5 6.16669Q18.5 6.48146 16.9871 6.98577Q14.9443 7.66669 12 7.66669Q9.05568 7.66669 7.01293 6.98577Q5.5012 6.48186 5.5 6.16719L5.5 6.16669L5.5 6.16622Q5.50113 5.85154 7.01293 5.34761Q9.05568 4.66669 12 4.66669Q14.9443 4.66669 16.9871 5.34761ZM12 9.66669Q7.62311 9.66669 5.5 8.73866L5.5 12Q5.5 12.318 7.00417 12.8202Q9.04041 13.5 12 13.5Q14.9596 13.5 16.9958 12.8202Q18.5 12.318 18.5 12L18.5 8.73866Q16.3769 9.66669 12 9.66669ZM5.5 17.8334L5.5 14.572Q7.62311 15.5 12 15.5Q16.3769 15.5 18.5 14.572L18.5 17.8334Q18.5 18.1514 16.9958 18.6536Q14.9596 19.3334 12 19.3334Q9.04041 19.3334 7.00417 18.6536Q5.5 18.1514 5.5 17.8334Z"
      fill="currentColor"
    />
  </svg>
);

// @src: lucide grip-vertical
export const DragHandle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 5Q11 7 9 7Q7 7 7 5Q7 3 9 3Q11 3 11 5ZM17 5Q17 7 15 7Q13 7 13 5Q13 3 15 3Q17 3 17 5ZM11 12Q11 14 9 14Q7 14 7 12Q7 10 9 10Q11 10 11 12ZM17 12Q17 14 15 14Q13 14 13 12Q13 10 15 10Q17 10 17 12ZM11 19Q11 21 9 21Q7 21 7 19Q7 17 9 17Q11 17 11 19ZM17 19Q17 21 15 21Q13 21 13 19Q13 17 15 17Q17 17 17 19Z"
      fill="currentColor"
    />
  </svg>
);

export const DollarSign = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.9074 21C11.3552 21 10.9074 20.5522 10.9074 20V18.85C10.0241 18.65 9.2616 18.2666 8.61994 17.7C8.16615 17.2992 7.79781 16.7818 7.5149 16.1476C7.30605 15.6795 7.57198 15.1522 8.04705 14.9596C8.58891 14.7399 9.19159 15.0401 9.48652 15.545C9.67997 15.8761 9.90778 16.1528 10.1699 16.375C10.6616 16.7916 11.3074 17 12.1074 17C12.7908 17 13.3699 16.8458 13.8449 16.5375C14.3199 16.2291 14.5574 15.75 14.5574 15.1C14.5574 14.5166 14.3741 14.0541 14.0074 13.7125C13.6408 13.3708 12.7908 12.9833 11.4574 12.55C10.0241 12.1 9.04077 11.5625 8.50744 10.9375C7.9741 10.3125 7.70744 9.54995 7.70744 8.64995C7.70744 7.56662 8.05744 6.72495 8.75744 6.12495C9.45744 5.52495 10.1741 5.18329 10.9074 5.09995V3.99995C10.9074 3.44767 11.3552 2.99995 11.9074 2.99995C12.4597 2.99995 12.9074 3.44767 12.9074 3.99995V5.09995C13.7408 5.23329 14.4283 5.53745 14.9699 6.01245C15.2722 6.27751 15.529 6.57501 15.7405 6.90494C16.0265 7.35116 15.7773 7.91434 15.2908 8.1247L15.2718 8.13294C14.7471 8.35985 14.1635 8.07311 13.7833 7.64626C13.6831 7.53389 13.5745 7.43512 13.4574 7.34995C13.0908 7.08329 12.5908 6.94995 11.9574 6.94995C11.2241 6.94995 10.6658 7.11245 10.2824 7.43745C9.8991 7.76245 9.70744 8.16662 9.70744 8.64995C9.70744 9.19995 9.95744 9.63329 10.4574 9.94995C10.9574 10.2666 11.8241 10.6 13.0574 10.95C14.2074 11.2833 15.0783 11.8125 15.6699 12.5375C16.2616 13.2625 16.5574 14.1 16.5574 15.05C16.5574 16.2333 16.2074 17.1333 15.5074 17.75C14.8074 18.3666 13.9408 18.75 12.9074 18.9V20C12.9074 20.5522 12.4597 21 11.9074 21Z" />
  </svg>
);

export const Download = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="download">
        <rect width="24" height="24" opacity="0" />
        <rect x="4" y="18" width="16" height="2" rx="1" ry="1" />
        <rect
          x="3"
          y="17"
          width="4"
          height="2"
          rx="1"
          ry="1"
          transform="rotate(-90 5 18)"
        />
        <rect
          x="17"
          y="17"
          width="4"
          height="2"
          rx="1"
          ry="1"
          transform="rotate(-90 19 18)"
        />
        <path d="M12 15a1 1 0 0 1-.58-.18l-4-2.82a1 1 0 0 1-.24-1.39 1 1 0 0 1 1.4-.24L12 12.76l3.4-2.56a1 1 0 0 1 1.2 1.6l-4 3a1 1 0 0 1-.6.2z" />
        <path d="M12 13a1 1 0 0 1-1-1V4a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1z" />
      </g>
    </g>
  </svg>
);

export const Duplicate = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 13V12C9 10.346 10.346 9 12 9H13V5.667C13 5.299 12.701 5 12.333 5H5.667C5.299 5 5 5.299 5 5.667V12.333C5 12.701 5.299 13 5.667 13H9ZM9 15H5.667C4.196 15 3 13.804 3 12.333V5.667C3 4.196 4.196 3 5.667 3H12.333C13.804 3 15 4.196 15 5.667V9H18C19.654 9 21 10.346 21 12V18C21 19.654 19.654 21 18 21H12C10.346 21 9 19.654 9 18V15ZM12 11C11.449 11 11 11.449 11 12V18C11 18.551 11.449 19 12 19H18C18.552 19 19 18.551 19 18V12C19 11.449 18.552 11 18 11H12Z"
    />
    <mask
      id="mask0_725_12898"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="18"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 13V12C9 10.346 10.346 9 12 9H13V5.667C13 5.299 12.701 5 12.333 5H5.667C5.299 5 5 5.299 5 5.667V12.333C5 12.701 5.299 13 5.667 13H9ZM9 15H5.667C4.196 15 3 13.804 3 12.333V5.667C3 4.196 4.196 3 5.667 3H12.333C13.804 3 15 4.196 15 5.667V9H18C19.654 9 21 10.346 21 12V18C21 19.654 19.654 21 18 21H12C10.346 21 9 19.654 9 18V15ZM12 11C11.449 11 11 11.449 11 12V18C11 18.551 11.449 19 12 19H18C18.552 19 19 18.551 19 18V12C19 11.449 18.552 11 18 11H12Z"
      />
    </mask>
    <g mask="url(#mask0_725_12898)"></g>
  </svg>
);

//E
export const Edit = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="edit">
        <rect width="24" height="24" opacity="0" />
        <path d="M19.4 7.34L16.66 4.6A2 2 0 0 0 14 4.53l-9 9a2 2 0 0 0-.57 1.21L4 18.91a1 1 0 0 0 .29.8A1 1 0 0 0 5 20h.09l4.17-.38a2 2 0 0 0 1.21-.57l9-9a1.92 1.92 0 0 0-.07-2.71zM9.08 17.62l-3 .28.27-3L12 9.32l2.7 2.7zM16 10.68L13.32 8l1.95-2L18 8.73z" />
      </g>
    </g>
  </svg>
);

export const Edit2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="edit-2">
        <rect width="24" height="24" opacity="0" />
        <path d="M19 20H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2z" />
        <path d="M5 18h.09l4.17-.38a2 2 0 0 0 1.21-.57l9-9a1.92 1.92 0 0 0-.07-2.71L16.66 2.6A2 2 0 0 0 14 2.53l-9 9a2 2 0 0 0-.57 1.21L4 16.91a1 1 0 0 0 .29.8A1 1 0 0 0 5 18zM15.27 4L18 6.73l-2 1.95L13.32 6zm-8.9 8.91L12 7.32l2.7 2.7-5.6 5.6-3 .28z" />
      </g>
    </g>
  </svg>
);

export const ExternalLink = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="external-link">
        <rect width="24" height="24" opacity="0" />
        <path d="M20 11a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1z" />
        <path d="M16 5h1.58l-6.29 6.28a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L19 6.42V8a1 1 0 0 0 1 1 1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z" />
      </g>
    </g>
  </svg>
);

export const Expand = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="expand">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M20 5a1 1 0 0 0-1-1h-5a1 1 0 0 0 0 2h2.57l-3.28 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L18 7.42V10a1 1 0 0 0 1 1 1 1 0 0 0 1-1z" />
        <path d="M10.71 13.29a1 1 0 0 0-1.42 0L6 16.57V14a1 1 0 0 0-1-1 1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2H7.42l3.29-3.29a1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

// @src: lucide link-2
export const Link2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path fill="none" d="M9 17H7A5 5 0 0 1 7 7h2" />
    <path fill="none" d="M15 7h2a5 5 0 1 1 0 10h-2" />
    <line x1="8" x2="16" y1="12" y2="12" />
  </svg>
);

export const Eye = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.77475 4.16985C14.7548 4.01401 17.6914 8.65901 18.2231 9.58568C18.3698 9.84235 18.3698 10.1582 18.2231 10.4148C17.5114 11.6557 14.8314 15.7132 10.2256 15.8307C10.1573 15.8323 10.0889 15.8332 10.0206 15.8332C5.13475 15.8332 2.30142 11.329 1.77725 10.4148C1.62975 10.1582 1.62975 9.84235 1.77725 9.58568C2.48892 8.34485 5.16808 4.28651 9.77475 4.16985ZM10.1831 14.1648C6.59475 14.2482 4.25392 11.179 3.47725 9.99651C4.33225 8.65901 6.48558 5.92068 9.81725 5.83568C13.3914 5.74485 15.7456 8.82151 16.5223 10.004C15.6681 11.3415 13.5139 14.0798 10.1831 14.1648ZM7.08333 10.0002C7.08333 8.39185 8.39167 7.08351 10 7.08351C11.6083 7.08351 12.9167 8.39185 12.9167 10.0002C12.9167 11.6085 11.6083 12.9168 10 12.9168C8.39167 12.9168 7.08333 11.6085 7.08333 10.0002ZM8.75 10.0002C8.75 10.6893 9.31083 11.2502 10 11.2502C10.6892 11.2502 11.25 10.6893 11.25 10.0002C11.25 9.31101 10.6892 8.75018 10 8.75018C9.31083 8.75018 8.75 9.31101 8.75 10.0002Z"
    />
    <mask
      id="mask0_935_15127"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="4"
      width="18"
      height="12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.77475 4.16985C14.7548 4.01401 17.6914 8.65901 18.2231 9.58568C18.3698 9.84235 18.3698 10.1582 18.2231 10.4148C17.5114 11.6557 14.8314 15.7132 10.2256 15.8307C10.1573 15.8323 10.0889 15.8332 10.0206 15.8332C5.13475 15.8332 2.30142 11.329 1.77725 10.4148C1.62975 10.1582 1.62975 9.84235 1.77725 9.58568C2.48892 8.34485 5.16808 4.28651 9.77475 4.16985ZM10.1831 14.1648C6.59475 14.2482 4.25392 11.179 3.47725 9.99651C4.33225 8.65901 6.48558 5.92068 9.81725 5.83568C13.3914 5.74485 15.7456 8.82151 16.5223 10.004C15.6681 11.3415 13.5139 14.0798 10.1831 14.1648ZM7.08333 10.0002C7.08333 8.39185 8.39167 7.08351 10 7.08351C11.6083 7.08351 12.9167 8.39185 12.9167 10.0002C12.9167 11.6085 11.6083 12.9168 10 12.9168C8.39167 12.9168 7.08333 11.6085 7.08333 10.0002ZM8.75 10.0002C8.75 10.6893 9.31083 11.2502 10 11.2502C10.6892 11.2502 11.25 10.6893 11.25 10.0002C11.25 9.31101 10.6892 8.75018 10 8.75018C9.31083 8.75018 8.75 9.31101 8.75 10.0002Z"
      />
    </mask>
    <g mask="url(#mask0_935_15127)"></g>
  </svg>
);

export const EyeOff = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="eye-off">
        <rect width="24" height="24" opacity="0" />
        <path d="M4.71 3.29a1 1 0 0 0-1.42 1.42l5.63 5.63a3.5 3.5 0 0 0 4.74 4.74l5.63 5.63a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM12 13.5a1.5 1.5 0 0 1-1.5-1.5v-.07l1.56 1.56z" />
        <path d="M12.22 17c-4.3.1-7.12-3.59-8-5a13.7 13.7 0 0 1 2.24-2.72L5 7.87a15.89 15.89 0 0 0-2.87 3.63 1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25a9.48 9.48 0 0 0 3.23-.67l-1.58-1.58a7.74 7.74 0 0 1-1.7.25z" />
        <path d="M21.87 11.5c-.64-1.11-4.17-6.68-10.14-6.5a9.48 9.48 0 0 0-3.23.67l1.58 1.58a7.74 7.74 0 0 1 1.7-.25c4.29-.11 7.11 3.59 8 5a13.7 13.7 0 0 1-2.29 2.72L19 16.13a15.89 15.89 0 0 0 2.91-3.63 1 1 0 0 0-.04-1z" />
      </g>
    </g>
  </svg>
);

//F

export const File = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="file">
        <rect width="24" height="24" opacity="0" />
        <path d="M19.74 8.33l-5.44-6a1 1 0 0 0-.74-.33h-7A2.53 2.53 0 0 0 4 4.5v15A2.53 2.53 0 0 0 6.56 22h10.88A2.53 2.53 0 0 0 20 19.5V9a1 1 0 0 0-.26-.67zM17.65 9h-3.94a.79.79 0 0 1-.71-.85V4h.11zm-.21 11H6.56a.53.53 0 0 1-.56-.5v-15a.53.53 0 0 1 .56-.5H11v4.15A2.79 2.79 0 0 0 13.71 11H18v8.5a.53.53 0 0 1-.56.5z" />
      </g>
    </g>
  </svg>
);

export const FileText = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="file-text">
        <rect width="24" height="24" opacity="0" />
        <path d="M15 16H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z" />
        <path d="M9 14h3a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2z" />
        <path d="M19.74 8.33l-5.44-6a1 1 0 0 0-.74-.33h-7A2.53 2.53 0 0 0 4 4.5v15A2.53 2.53 0 0 0 6.56 22h10.88A2.53 2.53 0 0 0 20 19.5V9a1 1 0 0 0-.26-.67zM14 5l2.74 3h-2a.79.79 0 0 1-.74-.85zm3.44 15H6.56a.53.53 0 0 1-.56-.5v-15a.53.53 0 0 1 .56-.5H12v3.15A2.79 2.79 0 0 0 14.71 10H18v9.5a.53.53 0 0 1-.56.5z" />
      </g>
    </g>
  </svg>
);

export const Folder = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="folder">
        <rect width="24" height="24" opacity="0" />
        <path d="M19.5 20.5h-15A2.47 2.47 0 0 1 2 18.07V5.93A2.47 2.47 0 0 1 4.5 3.5h4.6a1 1 0 0 1 .77.37l2.6 3.18h7A2.47 2.47 0 0 1 22 9.48v8.59a2.47 2.47 0 0 1-2.5 2.43zM4 13.76v4.31a.46.46 0 0 0 .5.43h15a.46.46 0 0 0 .5-.43V9.48a.46.46 0 0 0-.5-.43H12a1 1 0 0 1-.77-.37L8.63 5.5H4.5a.46.46 0 0 0-.5.43z" />
      </g>
    </g>
  </svg>
);

/**
 * @deprecated Use {@link ListFilter} instead — the funnel glyph has been
 * replaced by the list-filter glyph for filtering affordances.
 */
export const Funnel = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="funnel">
        <rect width="24" height="24" opacity="0" />
        <path d="M13.9 22a1 1 0 0 1-.6-.2l-4-3.05a1 1 0 0 1-.39-.8v-3.27l-4.8-9.22A1 1 0 0 1 5 4h14a1 1 0 0 1 .86.49 1 1 0 0 1 0 1l-5 9.21V21a1 1 0 0 1-.55.9 1 1 0 0 1-.41.1zm-3-4.54l2 1.53v-4.55A1 1 0 0 1 13 14l4.3-8H6.64l4.13 8a1 1 0 0 1 .11.46z" />
      </g>
    </g>
  </svg>
);

//G

// @src: lucide
export const Gift = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path fill="none" d="M12 7v14" />
    <path fill="none" d="M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8" />
    <path
      fill="none"
      d="M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5"
    />
    <rect fill="none" x="3" y="7" width="18" height="4" rx="1" />
  </svg>
);

export const GitBranch = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 3L7 14.0718Q9.51222 14.4604 9.92069 16.9528Q12.6461 16.6676 14.6569 14.6569Q16.6676 12.6461 16.9528 9.92069Q14 9.43676 14 6Q14 2 18 2Q22 2 22 6Q22 9.48627 18.9615 9.93402Q18.6641 13.478 16.0711 16.0711Q13.478 18.6641 9.93402 18.9615Q9.48627 22 6 22Q2 22 2 18Q2 14.5359 5 14.0718L5 3Q5 2.90151 5.01921 2.80491Q5.03843 2.70831 5.07612 2.61732Q5.11381 2.52632 5.16853 2.44443Q5.22325 2.36254 5.29289 2.29289Q5.36254 2.22325 5.44443 2.16853Q5.52632 2.11381 5.61732 2.07612Q5.70831 2.03843 5.80491 2.01921Q5.90151 2 6 2Q6.09849 2 6.19509 2.01921Q6.29169 2.03843 6.38268 2.07612Q6.47368 2.11381 6.55557 2.16853Q6.63746 2.22325 6.70711 2.29289Q6.77675 2.36254 6.83147 2.44443Q6.88619 2.52632 6.92388 2.61732Q6.96157 2.70831 6.98078 2.80491Q7 2.90151 7 3ZM20 6Q20 8 18 8Q16 8 16 6Q16 4 18 4Q20 4 20 6ZM4 18Q4 16 6 16Q8 16 8 18Q8 20 6 20Q4 20 4 18Z"
      fill="currentColor"
    />
  </svg>
);

export const GitHub = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
  >
    <g data-name="Layer 2">
      <rect width="24" height="24" transform="rotate(180 12 12)" opacity="0" />
      <path d="M12 1A10.89 10.89 0 0 0 1 11.77 10.79 10.79 0 0 0 8.52 22c.55.1.75-.23.75-.52v-1.83c-3.06.65-3.71-1.44-3.71-1.44a2.86 2.86 0 0 0-1.22-1.58c-1-.66.08-.65.08-.65a2.31 2.31 0 0 1 1.68 1.11 2.37 2.37 0 0 0 3.2.89 2.33 2.33 0 0 1 .7-1.44c-2.44-.27-5-1.19-5-5.32a4.15 4.15 0 0 1 1.11-2.91 3.78 3.78 0 0 1 .11-2.84s.93-.29 3 1.1a10.68 10.68 0 0 1 5.5 0c2.1-1.39 3-1.1 3-1.1a3.78 3.78 0 0 1 .11 2.84A4.15 4.15 0 0 1 19 11.2c0 4.14-2.58 5.05-5 5.32a2.5 2.5 0 0 1 .75 2v2.95c0 .35.2.63.75.52A10.8 10.8 0 0 0 23 11.77 10.89 10.89 0 0 0 12 1" />
    </g>
  </svg>
);

export const GraduationCap = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 13.1183L21 12.2107L21 16Q21 16.0985 21.0192 16.1951Q21.0384 16.2917 21.0761 16.3827Q21.1138 16.4737 21.1685 16.5556Q21.2232 16.6375 21.2929 16.7071Q21.3625 16.7767 21.4444 16.8315Q21.5263 16.8862 21.6173 16.9239Q21.7083 16.9616 21.8049 16.9808Q21.9015 17 22 17Q22.0985 17 22.1951 16.9808Q22.2917 16.9616 22.3827 16.9239Q22.4737 16.8862 22.5556 16.8315Q22.6375 16.7767 22.7071 16.7071Q22.7768 16.6375 22.8315 16.5556Q22.8862 16.4737 22.9239 16.3827Q22.9616 16.2917 22.9808 16.1951Q23 16.0985 23 16L23 10.3091Q23.018 10.1541 23.0163 9.9864Q23.0027 8.67708 21.8023 8.16793L13.2445 4.26996Q12 3.70229 10.755 4.27018L2.1858 8.16982Q1.00118 8.68853 1.00118 9.996Q1.00118 11.3035 2.19882 11.828L5 13.1054L5 16Q5 17.8607 7.31015 19.0157Q9.27865 20 12 20Q14.7213 20 16.6899 19.0157Q19 17.8607 19 16L19 13.1183ZM20.9865 9.99404Q20.9932 9.99711 21 10.0001L21 10.0144L12.415 13.9102Q12 14.0995 11.5849 13.9101L3.00118 9.996L3.0142 9.99018L11.585 6.08982Q12 5.90053 12.4155 6.09004L20.9865 9.99404ZM7 16L7 14.0175L10.7551 15.7299Q12 16.2977 13.245 15.7298L17 14.0259L17 16Q17 18 12 18Q7 18 7 16Z"
      fill="currentColor"
    />
  </svg>
);

export const Globe = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM3.86967 12.9091C4.24314 16.2869 6.67176 19.0434 9.8782 19.9022C8.47686 17.8331 7.64695 15.4196 7.48473 12.9091H3.86967ZM16.5153 12.9091C16.353 15.4198 15.5224 17.833 14.1209 19.9022C17.3278 19.0436 19.7568 16.2872 20.1303 12.9091H16.5153ZM9.30913 12.9091C9.49413 15.3982 10.4321 17.7718 12 19.7122C13.5679 17.7718 14.5059 15.3982 14.6909 12.9091H9.30913ZM9.8782 4.09695C6.67165 4.95568 4.24315 7.71304 3.86967 11.0909H7.48473C7.64696 8.58011 8.47661 6.1662 9.8782 4.09695ZM12 4.28693C10.4319 6.22746 9.49407 8.60151 9.30913 11.0909H14.6909C14.5059 8.60151 13.5681 6.22746 12 4.28693ZM14.1209 4.09695C15.5227 6.16629 16.353 8.57994 16.5153 11.0909H20.1303C19.7568 7.71275 17.3279 4.95542 14.1209 4.09695Z"
    />
  </svg>
);

export const GridFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="grid">
        <rect width="24" height="24" opacity="0" />
        <path d="M9 3H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z" />
        <path d="M19 3h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z" />
        <path d="M9 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z" />
        <path d="M19 13h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z" />
      </g>
    </g>
  </svg>
);

export const Grid = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="grid">
        <rect width="24" height="24" opacity="0" />
        <path d="M9 3H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 9V5h4v4z" />
        <path d="M19 3h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-4 6V5h4v4z" />
        <path d="M9 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-4 6v-4h4v4z" />
        <path d="M19 13h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-4 6v-4h4v4z" />
      </g>
    </g>
  </svg>
);

export const GraphQL = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.657L20.958 6.828V17.172L12 22.343L3.042 17.172V6.828L12 1.657ZM4.048 7.409V15.006L10.629 3.61L4.048 7.409ZM12 3.242L4.415 16.379H19.585L12 3.242ZM18.58 17.384H5.42L12 21.183L18.58 17.384ZM19.952 15.006L13.373 3.61L19.952 7.409V15.006Z"
    />
    <circle cx="12" cy="2.237" r="2.117" />
    <circle cx="20.455" cy="7.119" r="2.117" />
    <circle cx="20.455" cy="16.882" r="2.117" />
    <circle cx="12" cy="21.763" r="2.117" />
    <circle cx="3.544" cy="16.882" r="2.117" />
    <circle cx="3.544" cy="7.119" r="2.117" />
  </svg>
);

export const HalfMoonHalfSun = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.88518 8.68896C7.75814 8.4835 8.40614 9.00284 8.68987 9.55225C8.95537 10.0667 8.99811 10.7297 8.74748 11.3081C8.5089 11.8599 8.44142 12.4705 8.55412 13.061C8.6669 13.6517 8.9541 14.1955 9.37932 14.6206C9.80454 15.0457 10.3483 15.3332 10.9389 15.4458C11.5295 15.5583 12.141 15.4903 12.6928 15.2515C13.2706 15.0017 13.9337 15.0425 14.4487 15.3081C14.9995 15.5924 15.5175 16.2418 15.311 17.1147C15.0236 18.3268 14.4175 19.4414 13.5561 20.3413C12.6946 21.2412 11.608 21.8949 10.4096 22.2349C9.21104 22.5748 7.94245 22.5885 6.73674 22.2749C5.53125 21.9612 4.43113 21.3314 3.55022 20.4507C2.66926 19.5698 2.0389 18.4697 1.72502 17.2642C1.41119 16.0584 1.42527 14.79 1.76506 13.5913C2.10485 12.3928 2.75795 11.3064 3.65764 10.4448C4.5575 9.58317 5.67196 8.97749 6.8842 8.68994L6.88518 8.68896ZM6.79924 10.8003C6.14594 11.0366 5.54625 11.4058 5.04143 11.8892C4.39866 12.5047 3.9316 13.281 3.68889 14.1372C3.44624 14.9934 3.43642 15.899 3.66057 16.7603C3.88477 17.6214 4.33503 18.4075 4.96428 19.0366C5.59353 19.6656 6.37957 20.1153 7.24065 20.3394C8.10182 20.5633 9.00763 20.5538 9.86369 20.311C10.7196 20.0682 11.4955 19.6011 12.1108 18.9585C12.5943 18.4534 12.9624 17.8525 13.1987 17.1987C12.3568 17.5028 11.4468 17.578 10.5639 17.4097C9.57969 17.2219 8.67386 16.743 7.96526 16.0347C7.25661 15.3261 6.77721 14.4204 6.58928 13.436C6.42069 12.5527 6.495 11.6425 6.79924 10.8003Z"
    />
    <path d="M11.5004 7.49951C12.8265 7.49953 14.0979 8.02669 15.0356 8.96436C15.9732 9.90203 16.5004 11.1734 16.5004 12.4995C16.5004 13.0518 16.0527 13.4995 15.5004 13.4995C14.9481 13.4995 14.5004 13.0518 14.5004 12.4995C14.5004 11.7039 14.1841 10.941 13.6215 10.3784C13.0589 9.81583 12.296 9.49953 11.5004 9.49951C10.9481 9.49951 10.5004 9.0518 10.5004 8.49951C10.5004 7.94723 10.9481 7.49951 11.5004 7.49951Z" />
    <path d="M21.5004 11.4995C22.0527 11.4996 22.5004 11.9473 22.5004 12.4995C22.5004 13.0518 22.0527 13.4995 21.5004 13.4995H19.5004C18.9481 13.4995 18.5004 13.0518 18.5004 12.4995C18.5004 11.9472 18.9481 11.4995 19.5004 11.4995H21.5004Z" />
    <path d="M17.7934 4.79248C18.1839 4.40207 18.8169 4.40206 19.2074 4.79248C19.5978 5.18298 19.5978 5.81604 19.2074 6.20654L17.9516 7.4624C17.5611 7.85289 16.9281 7.85283 16.5375 7.4624C16.1471 7.07187 16.147 6.43884 16.5375 6.04834L17.7934 4.79248Z" />
    <path d="M11.5004 1.49951C12.0527 1.49955 12.5004 1.94725 12.5004 2.49951V4.49951C12.5004 5.05177 12.0527 5.49947 11.5004 5.49951C10.9481 5.49951 10.5004 5.0518 10.5004 4.49951V2.49951C10.5004 1.94723 10.9481 1.49951 11.5004 1.49951Z" />
  </svg>
);

//H

export const HardDrive = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="hard-drive">
        <rect width="24" height="24" opacity="0" />
        <path d="M20.79 11.34l-3.34-6.68A3 3 0 0 0 14.76 3H9.24a3 3 0 0 0-2.69 1.66l-3.34 6.68a2 2 0 0 0-.21.9V18a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5.76a2 2 0 0 0-.21-.9zM8.34 5.55a1 1 0 0 1 .9-.55h5.52a1 1 0 0 1 .9.55L18.38 11H5.62zM18 19H6a1 1 0 0 1-1-1v-5h14v5a1 1 0 0 1-1 1z" />
        <path d="M16 15h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z" />
        <circle cx="8" cy="16" r="1" />
      </g>
    </g>
  </svg>
);

export const History = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M12.3436 2.13235C14.3214 2.13235 16.2548 2.71909 17.8993 3.8179C19.5437 4.91669 20.826 6.47802 21.5829 8.30521C22.3398 10.1325 22.5371 12.1437 22.1512 14.0835C21.7654 16.0232 20.8134 17.8052 19.4149 19.2036C18.0165 20.6021 16.2345 21.5541 14.2948 21.94C12.355 22.3258 10.3437 22.1285 8.51648 21.3716C6.68929 20.6147 5.12796 19.3324 4.02917 17.688C2.93036 16.0435 2.34363 14.1102 2.34363 12.1324C2.34363 11.5801 2.79134 11.1324 3.34363 11.1324C3.89591 11.1324 4.34363 11.5801 4.34363 12.1324C4.34363 13.7146 4.81321 15.2611 5.69226 16.5767C6.57127 17.8922 7.82039 18.9175 9.2821 19.523C10.7438 20.1284 12.3524 20.2877 13.9042 19.979C15.456 19.6704 16.882 18.9084 18.0009 17.7896C19.1197 16.6708 19.8816 15.2447 20.1903 13.6929C20.4989 12.1411 20.3397 10.5326 19.7343 9.07083C19.1287 7.60912 18.1035 6.36 16.788 5.48099C15.4729 4.6023 13.9272 4.13274 12.3456 4.13235C10.0882 4.14131 7.92171 5.02235 6.29871 6.59134L5.75769 7.13235H8.34363C8.89591 7.13235 9.34363 7.58007 9.34363 8.13235C9.34363 8.68464 8.89591 9.13235 8.34363 9.13235H3.34363C3.28696 9.13235 3.23171 9.12579 3.17761 9.11673C3.16721 9.11498 3.15672 9.11392 3.14636 9.11185C3.13486 9.10954 3.12354 9.10673 3.11218 9.10403C3.09161 9.09915 3.07095 9.09461 3.05066 9.08841C3.00201 9.07352 2.95522 9.05454 2.91003 9.03275C2.88819 9.02222 2.86677 9.01077 2.84558 8.99857C2.68479 8.90592 2.55212 8.77046 2.46375 8.60696C2.45632 8.59321 2.44997 8.57899 2.44324 8.56497C2.42143 8.51967 2.40146 8.47313 2.3866 8.42435C2.37141 8.37444 2.36158 8.32332 2.35437 8.272C2.34798 8.22632 2.34363 8.1798 2.34363 8.13235V3.13235C2.34363 2.58007 2.79134 2.13235 3.34363 2.13235C3.89591 2.13235 4.34363 2.58007 4.34363 3.13235V5.71829L4.89636 5.16556L5.28992 4.80228C7.23605 3.09439 9.73887 2.14217 12.3397 2.13235H12.3436Z" />
    <path d="M12.3436 6.13235C12.8959 6.13235 13.3436 6.58007 13.3436 7.13235V11.5142L16.7909 13.2378C17.2849 13.4848 17.4851 14.0856 17.2382 14.5796C16.9912 15.0736 16.3903 15.2739 15.8964 15.0269L11.8964 13.0269C11.5576 12.8575 11.3436 12.5111 11.3436 12.1324V7.13235C11.3436 6.58007 11.7913 6.13235 12.3436 6.13235Z" />
  </svg>
);

//I

export const ID = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path d="M9.57031 7.91936H7.34375V16.0795H9.57031V17.6781H2.94043V16.0795H5.16699V7.91936H2.94043V6.3217H9.57031V7.91936Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2285 6.3217C16.0558 6.3217 16.8208 6.41812 17.5234 6.61076C18.2374 6.80343 18.8556 7.12091 19.377 7.56291C19.9094 7.99346 20.3226 8.57134 20.6172 9.29631C20.9119 10.0216 21.0596 10.9175 21.0596 11.9828C21.0596 13.0481 20.9118 13.9493 20.6172 14.686C20.3225 15.4111 19.9095 15.995 19.377 16.4369C18.8556 16.8789 18.2374 17.1964 17.5234 17.3891C16.8208 17.5817 16.0557 17.6781 15.2285 17.6781H12.084V6.3217H15.2285ZM14.1064 15.893H15.127C15.6255 15.893 16.1015 15.8416 16.5547 15.7397C17.0193 15.6377 17.4333 15.4564 17.7959 15.1957C18.1584 14.9238 18.4415 14.5327 18.6455 14.0229C18.8608 13.5016 18.9687 12.8214 18.9688 11.9828C18.9688 11.1442 18.8608 10.4694 18.6455 9.9594C18.4415 9.43827 18.1584 9.04716 17.7959 8.78654C17.4332 8.51455 17.0193 8.33327 16.5547 8.2426C16.1015 8.14062 15.6255 8.0893 15.127 8.08928H14.1064V15.893Z"
    />
  </svg>
);

export const Image = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="image">
        <rect width="24" height="24" opacity="0" />
        <path d="M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM6 5h12a1 1 0 0 1 1 1v8.36l-3.2-2.73a2.77 2.77 0 0 0-3.52 0L5 17.7V6a1 1 0 0 1 1-1zm12 14H6.56l7-5.84a.78.78 0 0 1 .93 0L19 17v1a1 1 0 0 1-1 1z" />
        <circle cx="8" cy="8.5" r="1.5" />
      </g>
    </g>
  </svg>
);

export const InfoFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="info">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1 14a1 1 0 0 1-2 0v-5a1 1 0 0 1 2 0zm-1-7a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
      </g>
    </g>
  </svg>
);

export const Info = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="info">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <circle cx="12" cy="8" r="1" />
        <path d="M12 10a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

//K
export const Key = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7071 2.70711L20.4142 4L22.7071 6.29289Q22.7768 6.36254 22.8315 6.44443Q22.8862 6.52632 22.9239 6.61732Q22.9616 6.70831 22.9808 6.80491Q23 6.90151 23 7Q23 7.09849 22.9808 7.19509Q22.9616 7.29169 22.9239 7.38268Q22.8862 7.47368 22.8315 7.55557Q22.7768 7.63746 22.7071 7.70711L19.2071 11.2071Q19.1375 11.2767 19.0556 11.3315Q18.9737 11.3862 18.8827 11.4239Q18.7917 11.4616 18.6951 11.4808Q18.5985 11.5 18.5 11.5Q18.4015 11.5 18.3049 11.4808Q18.2083 11.4616 18.1173 11.4239Q18.0263 11.3862 17.9444 11.3315Q17.8625 11.2767 17.7929 11.2071L15.5 8.91421L12.7592 11.655Q14.0197 13.3159 14.027 15.5033Q14.0361 18.2084 12.1232 20.1212Q10.2104 22.0341 7.50528 22.025Q4.80015 22.0159 2.90017 20.0904Q1.0452 18.1699 1.0683 15.5106Q1.0914 12.8513 2.97186 10.9709Q4.85233 9.0904 7.5116 9.0673Q9.66513 9.0486 11.3291 10.2566L14.7929 6.79289L18.2929 3.29289L20.2929 1.29289Q20.3625 1.22325 20.4444 1.16853Q20.5263 1.11381 20.6173 1.07612Q20.7083 1.03843 20.8049 1.01921Q20.9015 1 21 1Q21.0985 1 21.1951 1.01921Q21.2917 1.03843 21.3827 1.07612Q21.4737 1.11381 21.5556 1.16853Q21.6375 1.22325 21.7071 1.29289Q21.8478 1.43355 21.9239 1.61732Q22 1.80109 22 2Q22 2.19891 21.9239 2.38268Q21.8478 2.56645 21.7071 2.70711ZM20.5858 7L19 5.41421L16.9142 7.5L18.5 9.08579L20.5858 7ZM10.6943 12.3303Q10.708 12.3435 10.7222 12.3562Q12.0208 13.6616 12.027 15.51Q12.0333 17.3828 10.709 18.707Q9.38476 20.0313 7.51197 20.025Q5.63919 20.0187 4.32382 18.6856Q3.05224 17.369 3.06823 15.528Q3.08422 13.6869 4.38608 12.3851Q5.68794 11.0832 7.52897 11.0672Q9.37 11.0512 10.6943 12.3303Z"
      fill="currentColor"
    />
  </svg>
);
//L

export const LifeBuoy = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 12Q23 16.5564 19.7782 19.7782Q16.5564 23 12 23Q7.44365 23 4.22183 19.7782Q0.999999 16.5563 0.999999 12Q1 7.44365 4.22183 4.22183Q7.44365 1 12 1Q16.5563 1 19.7782 4.22183Q23 7.44365 23 12ZM14.7634 7.8224L17.6219 4.96385Q15.2177 3 12 3Q8.7823 3 6.37806 4.96385L9.23662 7.8224Q10.448 7 12 7Q13.552 7 14.7634 7.8224ZM3 12Q3 8.7823 4.96385 6.37806L7.8224 9.23662Q7 10.448 7 12Q7 13.552 7.8224 14.7634L4.96385 17.6219Q3 15.2177 3 12ZM21 12Q21 8.7823 19.0362 6.37806L16.1776 9.23662Q17 10.448 17 12Q17 13.552 16.1776 14.7634L19.0362 17.6219Q21 15.2177 21 12ZM9 12Q9 10.8419 9.44708 10.1308Q9.6948 10.0594 9.87711 9.87711Q10.0594 9.6948 10.1308 9.44708Q10.8419 9 12 9Q13.1581 9 13.8692 9.44708Q13.9406 9.6948 14.1229 9.87711Q14.3052 10.0594 14.5529 10.1308Q15 10.8419 15 12Q15 13.1581 14.5529 13.8692Q14.3052 13.9406 14.1229 14.1229Q13.9406 14.3052 13.8692 14.5529Q13.1581 15 12 15Q10.8419 15 10.1308 14.5529Q10.0594 14.3052 9.87711 14.1229Q9.6948 13.9406 9.44708 13.8692Q9 13.1581 9 12ZM12 17Q13.552 17 14.7634 16.1776L17.6219 19.0362Q15.2177 21 12 21Q8.7823 21 6.37806 19.0362L9.23662 16.1776Q10.448 17 12 17Z"
      fill="currentColor"
    />
  </svg>
);

export const List = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="list">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <circle cx="4" cy="7" r="1" />
        <circle cx="4" cy="12" r="1" />
        <circle cx="4" cy="17" r="1" />
        <rect x="7" y="11" width="14" height="2" rx=".94" ry=".94" />
        <rect x="7" y="16" width="14" height="2" rx=".94" ry=".94" />
        <rect x="7" y="6" width="14" height="2" rx=".94" ry=".94" />
      </g>
    </g>
  </svg>
);

export const ListFilter = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M2 5h20" />
    <path d="M6 12h12" />
    <path d="M9 19h6" />
  </svg>
);

export const Loader = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="loader">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 2a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1z" />
        <path d="M21 11h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z" />
        <path d="M6 12a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1z" />
        <path d="M6.22 5a1 1 0 0 0-1.39 1.47l1.44 1.39a1 1 0 0 0 .73.28 1 1 0 0 0 .72-.31 1 1 0 0 0 0-1.41z" />
        <path d="M17 8.14a1 1 0 0 0 .69-.28l1.44-1.39A1 1 0 0 0 17.78 5l-1.44 1.42a1 1 0 0 0 0 1.41 1 1 0 0 0 .66.31z" />
        <path d="M12 18a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1z" />
        <path d="M17.73 16.14a1 1 0 0 0-1.39 1.44L17.78 19a1 1 0 0 0 .69.28 1 1 0 0 0 .72-.3 1 1 0 0 0 0-1.42z" />
        <path d="M6.27 16.14l-1.44 1.39a1 1 0 0 0 0 1.42 1 1 0 0 0 .72.3 1 1 0 0 0 .67-.25l1.44-1.39a1 1 0 0 0-1.39-1.44z" />
      </g>
    </g>
  </svg>
);

export const Loading = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={css`
      animation: ${loadingCircleKeyframes} 1s infinite linear;
    `}
  >
    <g id="loading">
      <mask
        id="mask0_804_24"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12ZM4 12C4 16.411 7.589 20 12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4C7.589 4 4 7.589 4 12Z"
          fill="inherit"
        />
      </mask>
      <g mask="url(#mask0_804_24)">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2C11.4477 2 11 2.44772 11 3C11 3.55228 11.4477 4 12 4V12H20C20 12.5523 20.4477 13 21 13C21.5523 13 22 12.5523 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612Z"
          fill="inherit"
        />
      </g>
    </g>
  </svg>
);

export const LogOut = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="log-out">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M7 6a1 1 0 0 0 0-2H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2H6V6z" />
        <path d="M20.82 11.42l-2.82-4a1 1 0 0 0-1.39-.24 1 1 0 0 0-.24 1.4L18.09 11H10a1 1 0 0 0 0 2h8l-1.8 2.4a1 1 0 0 0 .2 1.4 1 1 0 0 0 .6.2 1 1 0 0 0 .8-.4l3-4a1 1 0 0 0 .02-1.18z" />
      </g>
    </g>
  </svg>
);

//M

// @src: lucide message-circle
export const MessageCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      fill="none"
      d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"
    />
  </svg>
);

// @src: lucide message-circle-plus
export const MessageCirclePlus = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      fill="none"
      d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"
    />
    <path fill="none" d="M8 12h8" />
    <path fill="none" d="M12 8v8" />
  </svg>
);

export const MessageSquare = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="message-square">
        <rect width="24" height="24" opacity="0" />
        <circle cx="12" cy="11" r="1" />
        <circle cx="16" cy="11" r="1" />
        <circle cx="8" cy="11" r="1" />
        <path d="M19 3H5a3 3 0 0 0-3 3v15a1 1 0 0 0 .51.87A1 1 0 0 0 3 22a1 1 0 0 0 .51-.14L8 19.14a1 1 0 0 1 .55-.14H19a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm1 13a1 1 0 0 1-1 1H8.55a3 3 0 0 0-1.55.43l-3 1.8V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z" />
      </g>
    </g>
  </svg>
);

export const MessagesSquare = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{ fill: "none", stroke: "currentColor" }}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    <path d="M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1" />
  </svg>
);

export const MinusCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="minus-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M15 11H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const Minus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="minus">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M19 13H5a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2z" />
      </g>
    </g>
  </svg>
);

export const Moon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.279 21.9783H12.179C10.8075 21.9678 9.4519 21.6838 8.19154 21.1429C6.93119 20.602 5.79142 19.8151 4.83898 18.8283C3.07283 16.9395 2.06886 14.4636 2.02085 11.8782C1.97283 9.29278 2.88417 6.78124 4.57898 4.82825C5.67086 3.60459 7.04351 2.66433 8.57898 2.08825C8.75814 2.01931 8.95336 2.00339 9.14133 2.0424C9.32929 2.08142 9.50205 2.1737 9.63898 2.30825C9.7658 2.43757 9.85511 2.59891 9.89738 2.77503C9.93965 2.95116 9.93329 3.13546 9.87898 3.30825C9.33094 4.80919 9.22236 6.4353 9.56598 7.99577C9.9096 9.55625 10.6912 10.9863 11.819 12.1183C12.9573 13.2426 14.3908 14.0215 15.9535 14.3649C17.5162 14.7082 19.1442 14.6019 20.649 14.0583C20.8281 13.9952 21.0214 13.9845 21.2064 14.0273C21.3914 14.0701 21.5604 14.1646 21.6936 14.3C21.8268 14.4353 21.9188 14.6057 21.9587 14.7913C21.9986 14.977 21.9848 15.1701 21.919 15.3483C21.4081 16.712 20.6101 17.9499 19.579 18.9783C18.6198 19.9346 17.4811 20.6919 16.2284 21.2067C14.9756 21.7216 13.6334 21.9838 12.279 21.9783ZM7.43898 4.89825C6.93666 5.25055 6.47691 5.65995 6.06898 6.11825C4.69352 7.69439 3.9524 9.72517 3.98935 11.8168C4.02631 13.9083 4.8387 15.9117 6.26898 17.4382C7.03751 18.2364 7.95825 18.8725 8.97678 19.3087C9.99531 19.745 11.091 19.9727 12.199 19.9783H12.279C13.6052 19.9775 14.9121 19.6605 16.0912 19.0535C17.2704 18.4466 18.2878 17.5671 19.059 16.4883C17.4873 16.6919 15.8899 16.5326 14.3894 16.0226C12.8889 15.5127 11.5253 14.6656 10.4032 13.5464C9.28114 12.4272 8.43051 11.0658 7.91666 9.5666C7.40281 8.06743 7.2394 6.47042 7.43898 4.89825Z" />
  </svg>
);

export const MoreHorizontal = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="more-horizotnal">
        <rect width="24" height="24" opacity="0" />
        <circle cx="12" cy="12" r="2" />
        <circle cx="19" cy="12" r="2" />
        <circle cx="5" cy="12" r="2" />
      </g>
    </g>
  </svg>
);

export const Options = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="options">
        <rect width="24" height="24" opacity="0" />
        <path d="M7 14.18V3a1 1 0 0 0-2 0v11.18a3 3 0 0 0 0 5.64V21a1 1 0 0 0 2 0v-1.18a3 3 0 0 0 0-5.64zM6 18a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
        <path d="M21 13a3 3 0 0 0-2-2.82V3a1 1 0 0 0-2 0v7.18a3 3 0 0 0 0 5.64V21a1 1 0 0 0 2 0v-5.18A3 3 0 0 0 21 13zm-3 1a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
        <path d="M15 5a3 3 0 1 0-4 2.82V21a1 1 0 0 0 2 0V7.82A3 3 0 0 0 15 5zm-3 1a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
      </g>
    </g>
  </svg>
);

//P
export const PaperPlane = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="paper-plane">
        <rect width="24" height="24" opacity="0" />
        <path d="M21 4a1.31 1.31 0 0 0-.06-.27v-.09a1 1 0 0 0-.2-.3 1 1 0 0 0-.29-.19h-.09a.86.86 0 0 0-.31-.15H20a1 1 0 0 0-.3 0l-18 6a1 1 0 0 0 0 1.9l8.53 2.84 2.84 8.53a1 1 0 0 0 1.9 0l6-18A1 1 0 0 0 21 4zm-4.7 2.29l-5.57 5.57L5.16 10zM14 18.84l-1.86-5.57 5.57-5.57z" />
      </g>
    </g>
  </svg>
);

export const Pause = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2L9 2Q11 2 11 4L11 20Q11 22 9 22L6 22Q4 22 4 20L4 4Q4 2 6 2ZM15 2L18 2Q20 2 20 4L20 20Q20 22 18 22L15 22Q13 22 13 20L13 4Q13 2 15 2ZM6 4L6 20L9 20L9 4L6 4ZM15 4L15 20L18 20L18 4L15 4Z"
      fill="currentColor"
    />
  </svg>
);

export const Person = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="person">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z" />
        <path d="M12 13a7 7 0 0 0-7 7 1 1 0 0 0 2 0 5 5 0 0 1 10 0 1 1 0 0 0 2 0 7 7 0 0 0-7-7z" />
      </g>
    </g>
  </svg>
);

export const PieChart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="pie-chart">
        <rect width="24" height="24" opacity="0" />
        <path d="M13 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 9 9 0 0 0-9-9zm1 8V4.07A7 7 0 0 1 19.93 10z" />
        <path d="M20.82 14.06a1 1 0 0 0-1.28.61A8 8 0 1 1 9.33 4.46a1 1 0 0 0-.66-1.89 10 10 0 1 0 12.76 12.76 1 1 0 0 0-.61-1.27z" />
      </g>
    </g>
  </svg>
);

export const Play = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 18.9997L4 5Q3.99961 3.26325 5.50563 2.39809Q7.01177 1.53286 8.512 2.4083L20.5089 9.40621Q21.9997 10.2713 22.0012 11.9973Q22.0027 13.7232 20.5114 14.5921L8.51187 21.5918Q7.01177 22.4671 5.50563 21.6019Q3.99948 20.7367 4 18.9997ZM6 4.9997L6 19.0003Q5.99983 19.5793 6.50187 19.8677Q7.00392 20.1561 7.50413 19.8642L19.5046 12.8639Q20.0017 12.5743 20.0012 11.999Q20.0007 11.4237 19.5011 11.1338L7.504 4.1357Q7.00392 3.84389 6.50187 4.1323Q5.99983 4.42071 6 4.9997Z"
      fill="currentColor"
    />
  </svg>
);

export const PlayCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="play-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M12.34 7.45a1.7 1.7 0 0 0-1.85-.3 1.6 1.6 0 0 0-1 1.48v6.74a1.6 1.6 0 0 0 1 1.48 1.68 1.68 0 0 0 .69.15 1.74 1.74 0 0 0 1.16-.45L16 13.18a1.6 1.6 0 0 0 0-2.36zm-.84 7.15V9.4l2.81 2.6z" />
      </g>
    </g>
  </svg>
);

export const Plus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="plus">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const PlusCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="plus-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M15 11h-2V9a1 1 0 0 0-2 0v2H9a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const PriceTags = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="pricetags">
        <rect width="24" height="24" opacity="0" />
        <path d="M12.87 22a1.84 1.84 0 0 1-1.29-.53l-6.41-6.42a1 1 0 0 1-.29-.61L4 5.09a1 1 0 0 1 .29-.8 1 1 0 0 1 .8-.29l9.35.88a1 1 0 0 1 .61.29l6.42 6.41a1.82 1.82 0 0 1 0 2.57l-7.32 7.32a1.82 1.82 0 0 1-1.28.53zm-6-8.11l6 6 7.05-7.05-6-6-7.81-.73z" />
        <circle cx="10.5" cy="10.5" r="1.5" />
      </g>
    </g>
  </svg>
);

export const PythonSVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.496 4.68179C16.7594 4.68179 17.3551 5.63521 17.6669 6.90249C18.1009 8.66251 18.1201 9.98168 17.6669 11.3537C17.2281 12.6865 16.7578 13.5744 15.496 13.5744H8.98918V14.131H13.3261V15.8009C13.3259 17.0646 12.248 17.7072 11.1552 18.0265C9.51085 18.5079 8.19258 18.4342 6.81828 18.0265C5.67068 17.686 4.64753 16.9878 4.64738 15.8009V11.63C4.64738 10.4299 5.63041 9.40347 6.81828 9.40347H11.1552C12.6 9.40325 13.8669 8.13478 13.8671 6.6271V4.68179H15.496ZM11.4277 15.2443C10.9794 15.2445 10.6132 15.6164 10.6132 16.0763C10.6132 16.5379 10.9794 16.913 11.4277 16.9132C11.8777 16.9132 12.2431 16.538 12.2431 16.0763C12.2431 15.6162 11.8777 15.2443 11.4277 15.2443Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.8925 0.000149919C9.63457 -0.00332877 10.4085 0.0536574 11.1542 0.178861C12.3324 0.376977 13.3251 1.26914 13.3251 2.4562V6.6271C13.3249 7.85004 12.3613 8.85269 11.1542 8.85269H6.81828C5.34599 8.85269 4.10554 10.1277 4.10539 11.5734V13.5753H2.6132C1.35139 13.5753 0.614206 12.6504 0.305585 11.3537C-0.11062 9.61183 -0.0930083 8.57077 0.305585 6.90249C0.651145 5.44704 1.75583 4.68193 3.0175 4.68179H8.98918V4.12515H4.64738V2.4562C4.64738 1.19219 4.98102 0.506326 6.81828 0.178861C7.44183 0.067561 8.15047 0.00364161 8.8925 0.000149919ZM6.54484 1.34292C6.09489 1.34292 5.73058 1.71828 5.73039 2.17984C5.73039 2.63993 6.09477 3.01187 6.54484 3.01187C6.99329 3.01185 7.3593 2.63991 7.3593 2.17984C7.35911 1.71829 6.99317 1.34294 6.54484 1.34292Z"
      fill="currentColor"
    />
  </svg>
);

//Q
export const Question = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="menu-arrow-circle">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M12 6a3.5 3.5 0 0 0-3.5 3.5 1 1 0 0 0 2 0A1.5 1.5 0 1 1 12 11a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-1.16A3.49 3.49 0 0 0 12 6z" />
        <circle cx="12" cy="17" r="1" />
      </g>
    </g>
  </svg>
);

export const RotateCcw = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3L4 5.58594L4.56496 5.02103Q7.67315 2.01627 12 2Q16.1421 2 19.0711 4.92893Q22 7.85786 22 12Q22 16.1421 19.0711 19.0711Q16.1421 22 12 22Q7.85786 22 4.92893 19.0711Q2 16.1421 2 12Q2 11.9015 2.01921 11.8049Q2.03843 11.7083 2.07612 11.6173Q2.11381 11.5263 2.16853 11.4444Q2.22325 11.3625 2.29289 11.2929Q2.36254 11.2232 2.44443 11.1685Q2.52632 11.1138 2.61732 11.0761Q2.70831 11.0384 2.80491 11.0192Q2.90151 11 3 11Q3.09849 11 3.19509 11.0192Q3.29169 11.0384 3.38268 11.0761Q3.47368 11.1138 3.55557 11.1685Q3.63746 11.2232 3.70711 11.2929Q3.77675 11.3625 3.83147 11.4444Q3.88619 11.5263 3.92388 11.6173Q3.96157 11.7083 3.98078 11.8049Q4 11.9015 4 12Q4 15.3137 6.34315 17.6569Q8.68629 20 12 20Q15.3137 20 17.6569 17.6569Q20 15.3137 20 12Q20 8.68629 17.6569 6.34315Q15.3137 4 12 4Q8.48497 4.01323 5.95504 6.45897L5.41406 7L8 7Q8.09849 7 8.19509 7.01922Q8.29169 7.03843 8.38268 7.07612Q8.47368 7.11381 8.55557 7.16853Q8.63746 7.22325 8.70711 7.29289Q8.77675 7.36254 8.83147 7.44443Q8.88619 7.52632 8.92388 7.61732Q8.96157 7.70831 8.98078 7.80491Q9 7.90151 9 8Q9 8.09849 8.98078 8.19509Q8.96157 8.29169 8.92388 8.38268Q8.88619 8.47368 8.83147 8.55557Q8.77675 8.63746 8.70711 8.70711Q8.63746 8.77675 8.55557 8.83147Q8.47368 8.88619 8.38268 8.92388Q8.29169 8.96157 8.19509 8.98078Q8.09849 9 8 9L3 9Q2.80109 9 2.61732 8.92388Q2.43355 8.84776 2.29289 8.70711Q2.15224 8.56645 2.07612 8.38268Q2 8.19891 2 8L2 3Q2 2.90151 2.01921 2.80491Q2.03843 2.70831 2.07612 2.61732Q2.11381 2.52632 2.16853 2.44443Q2.22325 2.36254 2.29289 2.29289Q2.36254 2.22325 2.44443 2.16853Q2.52632 2.11381 2.61732 2.07612Q2.70831 2.03843 2.80491 2.01921Q2.90151 2 3 2Q3.09849 2 3.19509 2.01921Q3.29169 2.03843 3.38268 2.07612Q3.47368 2.11381 3.55557 2.16853Q3.63746 2.22325 3.70711 2.29289Q3.77675 2.36254 3.83147 2.44443Q3.88619 2.52632 3.92388 2.61732Q3.96157 2.70831 3.98078 2.80491Q4 2.90151 4 3Z"
      fill="currentColor"
    />
  </svg>
);

export const Refresh = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="refresh">
        <rect width="24" height="24" opacity="0" />
        <path d="M20.3 13.43a1 1 0 0 0-1.25.65A7.14 7.14 0 0 1 12.18 19 7.1 7.1 0 0 1 5 12a7.1 7.1 0 0 1 7.18-7 7.26 7.26 0 0 1 4.65 1.67l-2.17-.36a1 1 0 0 0-1.15.83 1 1 0 0 0 .83 1.15l4.24.7h.17a1 1 0 0 0 .34-.06.33.33 0 0 0 .1-.06.78.78 0 0 0 .2-.11l.09-.11c0-.05.09-.09.13-.15s0-.1.05-.14a1.34 1.34 0 0 0 .07-.18l.75-4a1 1 0 0 0-2-.38l-.27 1.45A9.21 9.21 0 0 0 12.18 3 9.1 9.1 0 0 0 3 12a9.1 9.1 0 0 0 9.18 9A9.12 9.12 0 0 0 21 14.68a1 1 0 0 0-.7-1.25z" />
      </g>
    </g>
  </svg>
);

export const Repeat = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="repeat">
        <rect width="24" height="24" opacity="0" />
        <path d="M17.91 5h-12l1.3-1.29a1 1 0 0 0-1.42-1.42l-3 3a1 1 0 0 0 0 1.42l3 3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L5.91 7h12a1.56 1.56 0 0 1 1.59 1.53V11a1 1 0 0 0 2 0V8.53A3.56 3.56 0 0 0 17.91 5z" />
        <path d="M18.21 14.29a1 1 0 0 0-1.42 1.42l1.3 1.29h-12a1.56 1.56 0 0 1-1.59-1.53V13a1 1 0 0 0-2 0v2.47A3.56 3.56 0 0 0 6.09 19h12l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

export const Record = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7782 19.7782Q23 16.5563 23 12Q23 7.44365 19.7782 4.22183Q16.5563 1 12 1Q7.44365 1 4.22183 4.22183Q0.999999 7.44365 0.999999 12Q0.999998 16.5563 4.22182 19.7782Q7.44365 23 12 23Q16.5564 23 19.7782 19.7782ZM18.7175 5.28249Q21.5 8.06497 21.5 12Q21.5 15.935 18.7175 18.7175Q15.935 21.5 12 21.5Q8.06497 21.5 5.28249 18.7175Q2.5 15.935 2.5 12Q2.5 8.06497 5.28249 5.28249Q8.06497 2.5 12 2.5Q15.935 2.5 18.7175 5.28249ZM18 12Q18 12.1473 17.9928 12.2944Q17.9855 12.4415 17.9711 12.5881Q17.9567 12.7347 17.9351 12.8804Q17.9134 13.0261 17.8847 13.1705Q17.856 13.315 17.8202 13.4579Q17.7844 13.6008 17.7416 13.7417Q17.6989 13.8827 17.6493 14.0213Q17.5996 14.16 17.5433 14.2961Q17.4869 14.4322 17.4239 14.5653Q17.361 14.6985 17.2915 14.8284Q17.2221 14.9583 17.1464 15.0846Q17.0706 15.211 16.9888 15.3334Q16.907 15.4559 16.8192 15.5742Q16.7315 15.6925 16.6381 15.8064Q16.5446 15.9202 16.4457 16.0294Q16.3468 16.1385 16.2426 16.2426Q16.1385 16.3468 16.0294 16.4457Q15.9202 16.5446 15.8064 16.6381Q15.6925 16.7315 15.5742 16.8192Q15.4559 16.907 15.3334 16.9888Q15.211 17.0706 15.0846 17.1464Q14.9583 17.2221 14.8284 17.2915Q14.6985 17.361 14.5653 17.4239Q14.4322 17.4869 14.2961 17.5433Q14.16 17.5996 14.0213 17.6493Q13.8827 17.6989 13.7417 17.7416Q13.6008 17.7844 13.4579 17.8202Q13.315 17.856 13.1705 17.8847Q13.0261 17.9134 12.8804 17.9351Q12.7347 17.9567 12.5881 17.9711Q12.4415 17.9855 12.2944 17.9928Q12.1473 18 12 18Q11.8527 18 11.7056 17.9928Q11.5585 17.9855 11.4119 17.9711Q11.2653 17.9567 11.1196 17.9351Q10.9739 17.9134 10.8295 17.8847Q10.685 17.856 10.5421 17.8202Q10.3992 17.7844 10.2583 17.7416Q10.1173 17.6989 9.97866 17.6493Q9.83998 17.5996 9.7039 17.5433Q9.56782 17.4869 9.43467 17.4239Q9.30152 17.361 9.17162 17.2915Q9.04172 17.2221 8.91538 17.1464Q8.78905 17.0706 8.66658 16.9888Q8.54411 16.907 8.4258 16.8192Q8.3075 16.7315 8.19364 16.6381Q8.07978 16.5446 7.97065 16.4457Q7.86151 16.3468 7.75736 16.2426Q7.65321 16.1385 7.55429 16.0294Q7.45538 15.9202 7.36194 15.8064Q7.2685 15.6925 7.18075 15.5742Q7.09301 15.4559 7.01118 15.3334Q6.92935 15.211 6.85363 15.0846Q6.7779 14.9583 6.70847 14.8284Q6.63904 14.6985 6.57606 14.5653Q6.51309 14.4322 6.45672 14.2961Q6.40036 14.16 6.35073 14.0213Q6.30111 13.8827 6.25836 13.7417Q6.2156 13.6008 6.17981 13.4579Q6.14402 13.315 6.11529 13.1705Q6.08655 13.0261 6.06494 12.8804Q6.04333 12.7347 6.02889 12.5881Q6.01445 12.4415 6.00723 12.2944Q6 12.1473 6 12Q6 11.8527 6.00723 11.7056Q6.01445 11.5585 6.02889 11.4119Q6.04333 11.2653 6.06494 11.1196Q6.08655 10.9739 6.11529 10.8295Q6.14402 10.685 6.17981 10.5421Q6.2156 10.3992 6.25836 10.2583Q6.30111 10.1173 6.35074 9.97866Q6.40036 9.83998 6.45672 9.7039Q6.51309 9.56782 6.57606 9.43467Q6.63904 9.30152 6.70847 9.17162Q6.77791 9.04172 6.85363 8.91538Q6.92935 8.78905 7.01118 8.66658Q7.09301 8.54411 7.18076 8.4258Q7.2685 8.3075 7.36194 8.19364Q7.45538 8.07978 7.55429 7.97065Q7.65321 7.86151 7.75736 7.75736Q7.86151 7.65321 7.97065 7.55429Q8.07978 7.45538 8.19364 7.36194Q8.3075 7.2685 8.4258 7.18076Q8.54411 7.09301 8.66658 7.01118Q8.78905 6.92935 8.91538 6.85363Q9.04172 6.77791 9.17162 6.70847Q9.30152 6.63904 9.43467 6.57606Q9.56782 6.51309 9.7039 6.45672Q9.83998 6.40036 9.97866 6.35074Q10.1173 6.30111 10.2583 6.25836Q10.3992 6.2156 10.5421 6.17981Q10.685 6.14402 10.8295 6.11529Q10.9739 6.08655 11.1196 6.06494Q11.2653 6.04333 11.4119 6.02889Q11.5585 6.01445 11.7056 6.00723Q11.8527 6 12 6Q12.1473 6 12.2944 6.00723Q12.4415 6.01445 12.5881 6.02889Q12.7347 6.04333 12.8804 6.06494Q13.0261 6.08655 13.1705 6.11529Q13.315 6.14402 13.4579 6.17981Q13.6008 6.2156 13.7417 6.25836Q13.8827 6.30111 14.0213 6.35074Q14.16 6.40036 14.2961 6.45672Q14.4322 6.51309 14.5653 6.57606Q14.6985 6.63904 14.8284 6.70847Q14.9583 6.7779 15.0846 6.85363Q15.211 6.92935 15.3334 7.01118Q15.4559 7.09301 15.5742 7.18075Q15.6925 7.2685 15.8064 7.36194Q15.9202 7.45538 16.0294 7.55429Q16.1385 7.65321 16.2426 7.75736Q16.3468 7.86151 16.4457 7.97065Q16.5446 8.07978 16.6381 8.19364Q16.7315 8.3075 16.8192 8.4258Q16.907 8.54411 16.9888 8.66658Q17.0706 8.78905 17.1464 8.91538Q17.2221 9.04172 17.2915 9.17162Q17.361 9.30152 17.4239 9.43467Q17.4869 9.56782 17.5433 9.7039Q17.5996 9.83998 17.6493 9.97866Q17.6989 10.1173 17.7416 10.2583Q17.7844 10.3992 17.8202 10.5421Q17.856 10.685 17.8847 10.8295Q17.9134 10.9739 17.9351 11.1196Q17.9567 11.2653 17.9711 11.4119Q17.9855 11.5585 17.9928 11.7056Q18 11.8527 18 12Z"
      fill="currentColor"
    />
  </svg>
);

// @src: lucide
export const Rocket = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 2Q23 9.1491 17.1621 13.4074Q18.0512 16.7259 16.8312 18.556Q15.6255 20.3582 12.1786 20.9839Q12.09 21 12 21Q11.9015 21 11.8049 20.9808Q11.7083 20.9616 11.6173 20.9239Q11.5263 20.8862 11.4444 20.8315Q11.3625 20.7767 11.2929 20.7071Q11.2232 20.6375 11.1685 20.5556Q11.1138 20.4737 11.0761 20.3827Q11.0384 20.2917 11.0192 20.1951Q11 20.0985 11 20L11 15.4142L8.58579 13L4 13Q3.90151 13 3.80491 12.9808Q3.70831 12.9616 3.61732 12.9239Q3.52632 12.8862 3.44443 12.8315Q3.36254 12.7767 3.29289 12.7071Q3.22325 12.6375 3.16853 12.5556Q3.11381 12.4737 3.07612 12.3827Q3.03843 12.2917 3.01921 12.1951Q3 12.0985 3 12Q3 11.91 3.01608 11.8214Q3.64176 8.37445 5.44398 7.16883Q7.27585 5.94759 10.599 6.83968Q14.6669 0.954498 22.0062 1.00002Q22.1043 1.00063 22.2004 1.02029Q22.2965 1.03995 22.387 1.07791Q22.4774 1.11587 22.5588 1.17069Q22.6401 1.22551 22.7093 1.29509Q22.7784 1.36467 22.8328 1.44637Q22.8871 1.52806 22.9245 1.61875Q22.9619 1.70944 22.9809 1.80567Q23 1.9019 23 2ZM12.242 13.8278L10.1746 11.7604Q10.8714 10.1054 11.8422 8.58921Q15.0848 3.40467 20.9633 3.02903Q20.549 8.74003 15.4542 12.162Q13.917 13.1327 12.242 13.8278ZM5.25696 11L8.32476 11Q8.8381 9.77813 9.48772 8.62525Q7.505 8.19851 6.55602 8.83117Q5.73 9.38375 5.25696 11ZM13 18.743L13 15.6786Q14.2229 15.1717 15.3787 14.5305Q15.7986 16.4994 15.1688 17.444Q14.6163 18.27 13 18.743ZM3.85558 15.7353L3.85681 15.7343Q6.03748 13.8976 8.11259 15.8784Q10.161 17.9009 8.26571 20.1432Q6.75652 21.9398 2.63251 22.4912Q2.5 22.5089 2.36749 22.4912Q2.26987 22.4781 2.17667 22.4463Q2.08346 22.4144 1.99827 22.365Q1.91307 22.3156 1.83915 22.2505Q1.76523 22.1854 1.70543 22.1072Q1.64563 22.0289 1.60224 21.9405Q1.55886 21.8521 1.53356 21.7569Q1.50826 21.6617 1.50201 21.5634Q1.49577 21.4651 1.50882 21.3675Q2.05997 17.2449 3.85558 15.7353ZM5.14319 17.2657Q4.20309 18.0554 3.7236 20.2764Q5.94461 19.7969 6.7343 18.8568Q7.4386 18.0235 6.70741 17.3016Q5.95384 16.5825 5.14442 17.2647L5.14319 17.2657Z"
      fill="currentColor"
    />
  </svg>
);

export const RowCollapse = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 11.25C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75H3.9C4.31421 12.75 4.65 12.4142 4.65 12C4.65 11.5858 4.31421 11.25 3.9 11.25H3ZM5.7 11.25C5.28579 11.25 4.95 11.5858 4.95 12C4.95 12.4142 5.28579 12.75 5.7 12.75H7.5C7.91421 12.75 8.25 12.4142 8.25 12C8.25 11.5858 7.91421 11.25 7.5 11.25H5.7ZM9.3 11.25C8.88579 11.25 8.55 11.5858 8.55 12C8.55 12.4142 8.88579 12.75 9.3 12.75H11.1C11.5142 12.75 11.85 12.4142 11.85 12C11.85 11.5858 11.5142 11.25 11.1 11.25H9.3ZM12.9 11.25C12.4858 11.25 12.15 11.5858 12.15 12C12.15 12.4142 12.4858 12.75 12.9 12.75H14.7C15.1142 12.75 15.45 12.4142 15.45 12C15.45 11.5858 15.1142 11.25 14.7 11.25H12.9ZM16.5 11.25C16.0858 11.25 15.75 11.5858 15.75 12C15.75 12.4142 16.0858 12.75 16.5 12.75L18.3 12.75C18.7142 12.75 19.05 12.4142 19.05 12C19.05 11.5858 18.7142 11.25 18.3 11.25L16.5 11.25ZM20.1 11.25C19.6858 11.25 19.35 11.5858 19.35 12C19.35 12.4142 19.6858 12.75 20.1 12.75H21C21.4142 12.75 21.75 12.4142 21.75 12C21.75 11.5858 21.4142 11.25 21 11.25H20.1ZM12.5746 15.1596L15.5744 16.7468C16.0263 17.025 16.1363 17.571 15.8174 17.9656C15.4994 18.3611 14.8754 18.4564 14.4245 18.1782L12.9816 17.55C12.9829 17.5618 12.9867 17.5728 12.9904 17.5838C12.995 17.5974 12.9996 17.6108 12.9996 17.6252V21.1251C12.9996 21.608 12.5526 22 11.9997 22C11.4467 22 10.9998 21.608 10.9998 21.1251V17.6252V17.6243L9.59887 18.3252C9.15791 18.6148 8.53096 18.5369 8.19998 18.1502C8.06499 17.9927 8 17.8081 8 17.6261C8 17.3601 8.13799 17.0967 8.39997 16.9253L11.3997 15.1753C11.7457 14.9478 12.2207 14.9408 12.5746 15.1596ZM12.5746 8.84043L15.5744 7.25325C16.0263 6.97502 16.1363 6.42904 15.8174 6.03444C15.4994 5.63895 14.8754 5.54358 14.4245 5.82182L12.9816 6.45004C12.9829 6.43826 12.9867 6.42718 12.9904 6.41617C12.995 6.40266 12.9996 6.38926 12.9996 6.3748V2.87496C12.9996 2.39198 12.5526 2 11.9997 2C11.4467 2 10.9998 2.39198 10.9998 2.87496V6.3748V6.37567L9.59887 5.67483C9.15791 5.38522 8.53096 5.46309 8.19998 5.84982C8.06499 6.00731 8 6.19193 8 6.37392C8 6.63991 8.13799 6.90327 8.39997 7.07476L11.3997 8.82468C11.7457 9.05217 12.2207 9.05917 12.5746 8.84043Z"
      fill="currentColor"
    />
  </svg>
);

export const RowExpand = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 11.25C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75H3.9C4.31421 12.75 4.65 12.4142 4.65 12C4.65 11.5858 4.31421 11.25 3.9 11.25H3ZM5.7 11.25C5.28579 11.25 4.95 11.5858 4.95 12C4.95 12.4142 5.28579 12.75 5.7 12.75H7.5C7.91421 12.75 8.25 12.4142 8.25 12C8.25 11.5858 7.91421 11.25 7.5 11.25H5.7ZM9.3 11.25C8.88579 11.25 8.55 11.5858 8.55 12C8.55 12.4142 8.88579 12.75 9.3 12.75H11.1C11.5142 12.75 11.85 12.4142 11.85 12C11.85 11.5858 11.5142 11.25 11.1 11.25H9.3ZM12.9 11.25C12.4858 11.25 12.15 11.5858 12.15 12C12.15 12.4142 12.4858 12.75 12.9 12.75H14.7C15.1142 12.75 15.45 12.4142 15.45 12C15.45 11.5858 15.1142 11.25 14.7 11.25H12.9ZM16.5 11.25C16.0858 11.25 15.75 11.5858 15.75 12C15.75 12.4142 16.0858 12.75 16.5 12.75L18.3 12.75C18.7142 12.75 19.05 12.4142 19.05 12C19.05 11.5858 18.7142 11.25 18.3 11.25L16.5 11.25ZM20.1 11.25C19.6858 11.25 19.35 11.5858 19.35 12C19.35 12.4142 19.6858 12.75 20.1 12.75H21C21.4142 12.75 21.75 12.4142 21.75 12C21.75 11.5858 21.4142 11.25 21 11.25H20.1ZM11.4254 21.8405L8.42561 20.2533C7.97365 19.975 7.86366 19.4291 8.18263 19.0345C8.50061 18.639 9.12456 18.5436 9.57552 18.8219L11.0184 19.4501C11.0171 19.4383 11.0133 19.4272 11.0096 19.4162C11.005 19.4027 11.0004 19.3893 11.0004 19.3748V15.875C11.0004 15.392 11.4474 15 12.0003 15C12.5533 15 13.0002 15.392 13.0002 15.875V19.3748V19.3757L14.4011 18.6749C14.8421 18.3852 15.469 18.4631 15.8 18.8499C15.935 19.0073 16 19.192 16 19.374C16 19.6399 15.862 19.9033 15.6 20.0748L12.6003 21.8247C12.2543 22.0522 11.7793 22.0592 11.4254 21.8405ZM11.4254 2.1596L8.42561 3.74678C7.97365 4.02501 7.86366 4.57099 8.18263 4.96559C8.50061 5.36108 9.12456 5.45645 9.57552 5.17821L11.0184 4.54999C11.0171 4.56177 11.0133 4.57285 11.0096 4.58386C11.005 4.59737 11.0004 4.61077 11.0004 4.62523L11.0004 8.12507C11.0004 8.60805 11.4474 9.00003 12.0003 9.00003C12.5533 9.00003 13.0002 8.60805 13.0002 8.12507L13.0002 4.62523V4.62436L14.4011 5.3252C14.8421 5.61481 15.469 5.53694 15.8 5.15021C15.935 4.99272 16 4.8081 16 4.62611C16 4.36012 15.862 4.09676 15.6 3.92527L12.6003 2.17535C12.2543 1.94786 11.7793 1.94086 11.4254 2.1596Z"
      fill="currentColor"
    />
  </svg>
);
//S

export const Save = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g data-name="Layer 2">
        <g data-name="save">
          <rect width="24" height="24" opacity="0" />
          <path d="M20.12 8.71l-4.83-4.83A3 3 0 0 0 13.17 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7.17a3 3 0 0 0-.88-2.12zM10 19v-2h4v2zm9-1a1 1 0 0 1-1 1h-2v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2v5a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2h-3V5h3.17a1.05 1.05 0 0 1 .71.29l4.83 4.83a1 1 0 0 1 .29.71z" />
        </g>
      </g>
    </svg>
  );
};

export const Scale = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 3L13 4.37446Q16.4397 6 19 6L21 6Q21.0985 6 21.1951 6.01921Q21.2917 6.03843 21.3827 6.07612Q21.4737 6.11381 21.5556 6.16853Q21.6375 6.22325 21.7071 6.29289Q21.7767 6.36254 21.8315 6.44443Q21.8862 6.52632 21.9239 6.61732Q21.9616 6.70831 21.9808 6.80491Q22 6.90151 22 7Q22 7.09849 21.9808 7.19509Q21.9616 7.29169 21.9239 7.38268Q21.8862 7.47368 21.8315 7.55557Q21.7767 7.63746 21.7071 7.70711Q21.6375 7.77675 21.5556 7.83147Q21.4737 7.88619 21.3827 7.92388Q21.2917 7.96157 21.1951 7.98078Q21.0985 8 21 8L20.068 8L22.9363 15.6489Q22.9647 15.7244 22.9805 15.8035Q22.9964 15.8826 22.9993 15.9632Q23.0023 16.0438 22.9923 16.1239Q22.9823 16.2039 22.9596 16.2813Q22.9369 16.3587 22.9021 16.4315Q22.8673 16.5043 22.8213 16.5705Q22.7752 16.6368 22.7192 16.6948Q22.6631 16.7528 22.5985 16.8011Q20.9938 18 19 18Q17.0062 18 15.4015 16.8011Q15.3368 16.7528 15.2808 16.6948Q15.2248 16.6368 15.1787 16.5705Q15.1327 16.5043 15.0979 16.4315Q15.0631 16.3587 15.0404 16.2813Q15.0177 16.2039 15.0077 16.1239Q14.9977 16.0438 15.0007 15.9632Q15.0036 15.8826 15.0195 15.8035Q15.0353 15.7244 15.0637 15.6489L17.9518 7.94731Q15.6924 7.72534 13 6.56826L13 20L17 20Q17.0985 20 17.1951 20.0192Q17.2917 20.0384 17.3827 20.0761Q17.4737 20.1138 17.5556 20.1685Q17.6375 20.2232 17.7071 20.2929Q17.7767 20.3625 17.8315 20.4444Q17.8862 20.5263 17.9239 20.6173Q17.9616 20.7083 17.9808 20.8049Q18 20.9015 18 21Q18 21.0985 17.9808 21.1951Q17.9616 21.2917 17.9239 21.3827Q17.8862 21.4737 17.8315 21.5556Q17.7767 21.6375 17.7071 21.7071Q17.6375 21.7767 17.5556 21.8315Q17.4737 21.8862 17.3827 21.9239Q17.2917 21.9616 17.1951 21.9808Q17.0985 22 17 22L7 22Q6.90151 22 6.80491 21.9808Q6.70831 21.9616 6.61732 21.9239Q6.52632 21.8862 6.44443 21.8315Q6.36254 21.7767 6.29289 21.7071Q6.22325 21.6375 6.16853 21.5556Q6.11381 21.4737 6.07612 21.3827Q6.03843 21.2917 6.01921 21.1951Q6 21.0985 6 21Q6 20.9015 6.01921 20.8049Q6.03843 20.7083 6.07612 20.6173Q6.11381 20.5263 6.16853 20.4444Q6.22325 20.3625 6.29289 20.2929Q6.36254 20.2232 6.44443 20.1685Q6.52632 20.1138 6.61732 20.0761Q6.70831 20.0384 6.80491 20.0192Q6.90151 20 7 20L11 20L11 6.56826Q8.3076 7.72534 6.04824 7.94731L8.93633 15.6489Q8.96465 15.7244 8.9805 15.8035Q8.99636 15.8826 8.99932 15.9632Q9.00229 16.0438 8.9923 16.1239Q8.98231 16.2039 8.95961 16.2813Q8.93692 16.3587 8.90211 16.4315Q8.8673 16.5043 8.82127 16.5705Q8.77525 16.6368 8.7192 16.6948Q8.66315 16.7528 8.59853 16.8011Q6.99385 18 5 18Q3.00615 18 1.40147 16.8011Q1.33685 16.7528 1.2808 16.6948Q1.22475 16.6368 1.17873 16.5705Q1.1327 16.5043 1.09789 16.4315Q1.06308 16.3587 1.04039 16.2813Q1.0177 16.2039 1.0077 16.1239Q0.997709 16.0438 1.00068 15.9632Q1.00364 15.8826 1.0195 15.8035Q1.03535 15.7244 1.06367 15.6489L3.932 8L3 8Q2.90151 8 2.80491 7.98078Q2.70831 7.96157 2.61732 7.92388Q2.52632 7.88619 2.44443 7.83147Q2.36254 7.77675 2.29289 7.70711Q2.22325 7.63746 2.16853 7.55557Q2.11381 7.47368 2.07612 7.38268Q2.03843 7.29169 2.01921 7.19509Q2 7.09849 2 7Q2 6.90151 2.01921 6.80491Q2.03843 6.70831 2.07612 6.61732Q2.11381 6.52632 2.16853 6.44443Q2.22325 6.36254 2.29289 6.29289Q2.36254 6.22325 2.44443 6.16853Q2.52632 6.11381 2.61732 6.07612Q2.70831 6.03843 2.80491 6.01921Q2.90151 6 3 6L5 6Q7.56028 6 11 4.37446L11 3Q11 2.90151 11.0192 2.80491Q11.0384 2.70831 11.0761 2.61732Q11.1138 2.52632 11.1685 2.44443Q11.2232 2.36254 11.2929 2.29289Q11.3625 2.22325 11.4444 2.16853Q11.5263 2.11381 11.6173 2.07612Q11.7083 2.03843 11.8049 2.01921Q11.9015 2 12 2Q12.0985 2 12.1951 2.01921Q12.2917 2.03843 12.3827 2.07612Q12.4737 2.11381 12.5556 2.16853Q12.6375 2.22325 12.7071 2.29289Q12.7767 2.36254 12.8315 2.44443Q12.8862 2.52632 12.9239 2.61732Q12.9616 2.70831 12.9808 2.80491Q13 2.90151 13 3ZM17.223 15.5867L19 10.848L20.777 15.5867Q19.9548 16 19 16Q18.0452 16 17.223 15.5867ZM3.223 15.5867L5 10.848L6.777 15.5867Q5.95479 16 5 16Q4.04521 16 3.223 15.5867Z"
      fill="currentColor"
    />
  </svg>
);

// @src: lucide scan-text
export const ScanText = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path fill="none" d="M3 7V5a2 2 0 0 1 2-2h2" />
    <path fill="none" d="M17 3h2a2 2 0 0 1 2 2v2" />
    <path fill="none" d="M21 17v2a2 2 0 0 1-2 2h-2" />
    <path fill="none" d="M7 21H5a2 2 0 0 1-2-2v-2" />
    <path fill="none" d="M7 8h8" />
    <path fill="none" d="M7 12h10" />
    <path fill="none" d="M7 16h6" />
  </svg>
);

export const Search = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="search">
        <rect width="24" height="24" opacity="0" />
        <path d="M20.71 19.29l-3.4-3.39A7.92 7.92 0 0 0 19 11a8 8 0 1 0-8 8 7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM5 11a6 6 0 1 1 6 6 6 6 0 0 1-6-6z" />
      </g>
    </g>
  </svg>
);

export const Server = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 1L20 1Q23 1 23 4L23 8Q23 11 20 11L4 11Q1 11 1 8L1 4Q1 1 4 1ZM4 3Q3 3 3 4L3 8Q3 9 4 9L20 9Q21 9 21 8L21 4Q21 3 20 3L4 3ZM6 5L6.01 5Q6.10849 5 6.20509 5.01921Q6.30169 5.03843 6.39268 5.07612Q6.48368 5.11381 6.56557 5.16853Q6.64746 5.22325 6.71711 5.29289Q6.78675 5.36254 6.84147 5.44443Q6.89619 5.52632 6.93388 5.61732Q6.97157 5.70831 6.99079 5.80491Q7.01 5.90151 7.01 6Q7.01 6.09849 6.99079 6.19509Q6.97157 6.29169 6.93388 6.38268Q6.89619 6.47368 6.84147 6.55557Q6.78675 6.63746 6.71711 6.70711Q6.64746 6.77675 6.56557 6.83147Q6.48368 6.88619 6.39268 6.92388Q6.30169 6.96157 6.20509 6.98078Q6.10849 7 6.01 7L6 7Q5.90151 7 5.80491 6.98078Q5.70831 6.96157 5.61732 6.92388Q5.52632 6.88619 5.44443 6.83147Q5.36254 6.77675 5.29289 6.70711Q5.22325 6.63746 5.16853 6.55557Q5.11381 6.47368 5.07612 6.38268Q5.03843 6.29169 5.01921 6.19509Q5 6.09849 5 6Q5 5.90151 5.01921 5.80491Q5.03843 5.70831 5.07612 5.61732Q5.11381 5.52632 5.16853 5.44443Q5.22325 5.36254 5.29289 5.29289Q5.36254 5.22325 5.44443 5.16853Q5.52632 5.11381 5.61732 5.07612Q5.70831 5.03843 5.80491 5.01921Q5.90151 5 6 5ZM4 13L20 13Q23 13 23 16L23 20Q23 23 20 23L4 23Q1 23 1 20L1 16Q1 13 4 13ZM4 15Q3 15 3 16L3 20Q3 21 4 21L20 21Q21 21 21 20L21 16Q21 15 20 15L4 15ZM6 17L6.01 17Q6.10849 17 6.20509 17.0192Q6.30169 17.0384 6.39268 17.0761Q6.48368 17.1138 6.56557 17.1685Q6.64746 17.2232 6.71711 17.2929Q6.78675 17.3625 6.84147 17.4444Q6.89619 17.5263 6.93388 17.6173Q6.97157 17.7083 6.99079 17.8049Q7.01 17.9015 7.01 18Q7.01 18.0985 6.99079 18.1951Q6.97157 18.2917 6.93388 18.3827Q6.89619 18.4737 6.84147 18.5556Q6.78675 18.6375 6.71711 18.7071Q6.64746 18.7767 6.56557 18.8315Q6.48368 18.8862 6.39268 18.9239Q6.30169 18.9616 6.20509 18.9808Q6.10849 19 6.01 19L6 19Q5.90151 19 5.80491 18.9808Q5.70831 18.9616 5.61732 18.9239Q5.52632 18.8862 5.44443 18.8315Q5.36254 18.7767 5.29289 18.7071Q5.22325 18.6375 5.16853 18.5556Q5.11381 18.4737 5.07612 18.3827Q5.03843 18.2917 5.01921 18.1951Q5 18.0985 5 18Q5 17.9015 5.01921 17.8049Q5.03843 17.7083 5.07612 17.6173Q5.11381 17.5263 5.16853 17.4444Q5.22325 17.3625 5.29289 17.2929Q5.36254 17.2232 5.44443 17.1685Q5.52632 17.1138 5.61732 17.0761Q5.70831 17.0384 5.80491 17.0192Q5.90151 17 6 17Z"
      fill="currentColor"
    />
  </svg>
);

export const Settings = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="settings">
        <rect width="24" height="24" opacity="0" />
        <path
          d="M8.61 22a2.25 2.25 0 0 1-1.35-.46L5.19 20a2.37 2.37 0 0 1-.49-3.22 2.06 2.06 0 0 0 .23-1.86l-.06-.16a1.83 1.83 0 0 0-1.12-1.22h-.16a2.34 2.34 0 0 1-1.48-2.94L2.93 8a2.18 2.18 0 0 1 1.12-1.41 2.14 2.14 0 0 1 1.68-.12 1.93 1.93 0 0 0 1.78-.29l.13-.1a1.94 1.94 0 0 0 .73-1.51v-.24A2.32 2.32 0 0 1 10.66 2h2.55a2.26 2.26 0 0 1 1.6.67 2.37 2.37 0 0 1 .68 1.68v.28a1.76 1.76 0 0 0 .69 1.43l.11.08a1.74 1.74 0 0 0 1.59.26l.34-.11A2.26 2.26 0 0 1 21.1 7.8l.79 2.52a2.36 2.36 0 0 1-1.46 2.93l-.2.07A1.89 1.89 0 0 0 19 14.6a2 2 0 0 0 .25 1.65l.26.38a2.38 2.38 0 0 1-.5 3.23L17 21.41a2.24 2.24 0 0 1-3.22-.53l-.12-.17a1.75 1.75 0 0 0-1.5-.78 1.8 1.8 0 0 0-1.43.77l-.23.33A2.25 2.25 0 0 1 9 22a2 2 0 0 1-.39 0zM4.4 11.62a3.83 3.83 0 0 1 2.38 2.5v.12a4 4 0 0 1-.46 3.62.38.38 0 0 0 0 .51L8.47 20a.25.25 0 0 0 .37-.07l.23-.33a3.77 3.77 0 0 1 6.2 0l.12.18a.3.3 0 0 0 .18.12.25.25 0 0 0 .19-.05l2.06-1.56a.36.36 0 0 0 .07-.49l-.26-.38A4 4 0 0 1 17.1 14a3.92 3.92 0 0 1 2.49-2.61l.2-.07a.34.34 0 0 0 .19-.44l-.78-2.49a.35.35 0 0 0-.2-.19.21.21 0 0 0-.19 0l-.34.11a3.74 3.74 0 0 1-3.43-.57L15 7.65a3.76 3.76 0 0 1-1.49-3v-.31a.37.37 0 0 0-.1-.26.31.31 0 0 0-.21-.08h-2.54a.31.31 0 0 0-.29.33v.25a3.9 3.9 0 0 1-1.52 3.09l-.13.1a3.91 3.91 0 0 1-3.63.59.22.22 0 0 0-.14 0 .28.28 0 0 0-.12.15L4 11.12a.36.36 0 0 0 .22.45z"
          data-name="&lt;Group&gt;"
        />
        <path d="M12 15.5a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5zm0-5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5z" />
      </g>
    </g>
  </svg>
);

export const Share = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="share">
        <rect width="24" height="24" opacity="0" />
        <path d="M18 15a3 3 0 0 0-2.1.86L8 12.34V12v-.33l7.9-3.53A3 3 0 1 0 15 6v.34L7.1 9.86a3 3 0 1 0 0 4.28l7.9 3.53V18a3 3 0 1 0 3-3zm0-10a1 1 0 1 1-1 1 1 1 0 0 1 1-1zM5 13a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm13 6a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
      </g>
    </g>
  </svg>
);

export const Shield = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 13Q21 19.9905 12.6691 22.8943Q11.994 23.1231 11.3338 22.8818Q3 19.9999 3 13L3 6Q3 4 5 4Q7.75105 4 10.5821 1.52689Q12 0.315411 13.4096 1.5197Q16.2466 4 19 4Q21 4 21 6L21 13ZM19 13L19 6Q15.4956 6 12.1104 3.0403Q12 2.94595 11.8979 3.03311Q8.50159 6 5 6L5 13Q5 18.5788 11.9964 20.9948Q12.0078 20.9987 12.019 21.0029Q19 18.5663 19 13ZM13 8L13 12Q13 12.0985 12.9808 12.1951Q12.9616 12.2917 12.9239 12.3827Q12.8862 12.4737 12.8315 12.5556Q12.7767 12.6375 12.7071 12.7071Q12.6375 12.7767 12.5556 12.8315Q12.4737 12.8862 12.3827 12.9239Q12.2917 12.9616 12.1951 12.9808Q12.0985 13 12 13Q11.9015 13 11.8049 12.9808Q11.7083 12.9616 11.6173 12.9239Q11.5263 12.8862 11.4444 12.8315Q11.3625 12.7767 11.2929 12.7071Q11.2232 12.6375 11.1685 12.5556Q11.1138 12.4737 11.0761 12.3827Q11.0384 12.2917 11.0192 12.1951Q11 12.0985 11 12L11 8Q11 7.90151 11.0192 7.80491Q11.0384 7.70831 11.0761 7.61732Q11.1138 7.52632 11.1685 7.44443Q11.2232 7.36254 11.2929 7.29289Q11.3625 7.22325 11.4444 7.16853Q11.5263 7.11381 11.6173 7.07612Q11.7083 7.03843 11.8049 7.01921Q11.9015 7 12 7Q12.0985 7 12.1951 7.01922Q12.2917 7.03843 12.3827 7.07612Q12.4737 7.11381 12.5556 7.16853Q12.6375 7.22325 12.7071 7.29289Q12.7767 7.36254 12.8315 7.44443Q12.8862 7.52632 12.9239 7.61732Q12.9616 7.70831 12.9808 7.80491Q13 7.90151 13 8ZM12 15L12.01 15Q12.1085 15 12.2051 15.0192Q12.3017 15.0384 12.3927 15.0761Q12.4837 15.1138 12.5656 15.1685Q12.6475 15.2232 12.7171 15.2929Q12.7867 15.3625 12.8415 15.4444Q12.8962 15.5263 12.9339 15.6173Q12.9716 15.7083 12.9908 15.8049Q13.01 15.9015 13.01 16Q13.01 16.0985 12.9908 16.1951Q12.9716 16.2917 12.9339 16.3827Q12.8962 16.4737 12.8415 16.5556Q12.7867 16.6375 12.7171 16.7071Q12.6475 16.7767 12.5656 16.8315Q12.4837 16.8862 12.3927 16.9239Q12.3017 16.9616 12.2051 16.9808Q12.1085 17 12.01 17L12 17Q11.9015 17 11.8049 16.9808Q11.7083 16.9616 11.6173 16.9239Q11.5263 16.8862 11.4444 16.8315Q11.3625 16.7767 11.2929 16.7071Q11.2232 16.6375 11.1685 16.5556Q11.1138 16.4737 11.0761 16.3827Q11.0384 16.2917 11.0192 16.1951Q11 16.0985 11 16Q11 15.9015 11.0192 15.8049Q11.0384 15.7083 11.0761 15.6173Q11.1138 15.5263 11.1685 15.4444Q11.2232 15.3625 11.2929 15.2929Q11.3625 15.2232 11.4444 15.1685Q11.5263 15.1138 11.6173 15.0761Q11.7083 15.0384 11.8049 15.0192Q11.9015 15 12 15Z"
      fill="currentColor"
    />
  </svg>
);

export const Slack = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 6Q6 6 6 3.5Q6 1 8.5 1Q11 1 11 3.5L11 5Q11 5.09849 10.9808 5.19509Q10.9616 5.29169 10.9239 5.38268Q10.8862 5.47368 10.8315 5.55557Q10.7767 5.63746 10.7071 5.70711Q10.6375 5.77675 10.5556 5.83147Q10.4737 5.88619 10.3827 5.92388Q10.2917 5.96157 10.1951 5.98078Q10.0985 6 10 6L8.5 6ZM14.5 11Q12 11 12 8.5L12 3.5Q12 1 14.5 1Q17 1 17 3.5L17 8.5Q17 11 14.5 11ZM8.5 4L9 4L9 3.5Q9 3 8.5 3Q8 3 8 3.5Q8 4 8.5 4ZM14.5 9Q15 9 15 8.5L15 3.5Q15 3 14.5 3Q14 3 14 3.5L14 8.5Q14 9 14.5 9ZM20.5 11L19 11Q18.9015 11 18.8049 10.9808Q18.7083 10.9616 18.6173 10.9239Q18.5263 10.8862 18.4444 10.8315Q18.3625 10.7767 18.2929 10.7071Q18.2232 10.6375 18.1685 10.5556Q18.1138 10.4737 18.0761 10.3827Q18.0384 10.2917 18.0192 10.1951Q18 10.0985 18 10L18 8.5Q18 6 20.5 6Q23 6 23 8.5Q23 11 20.5 11ZM11 9.5Q11 12 8.5 12L3.5 12Q1 12 1 9.5Q1 7 3.5 7L8.5 7Q11 7 11 9.5ZM20.5 9Q21 9 21 8.5Q21 8 20.5 8Q20 8 20 8.5L20 9L20.5 9ZM9 9.5Q9 9 8.5 9L3.5 9Q3 9 3 9.5Q3 10 3.5 10L8.5 10Q9 10 9 9.5ZM13 14.5Q13 12 15.5 12L20.5 12Q23 12 23 14.5Q23 17 20.5 17L15.5 17Q13 17 13 14.5ZM3.5 13L5 13Q5.09849 13 5.19509 13.0192Q5.29169 13.0384 5.38268 13.0761Q5.47368 13.1138 5.55557 13.1685Q5.63746 13.2232 5.70711 13.2929Q5.77675 13.3625 5.83147 13.4444Q5.88619 13.5263 5.92388 13.6173Q5.96157 13.7083 5.98078 13.8049Q6 13.9015 6 14L6 15.5Q6 18 3.5 18Q1 18 1 15.5Q1 13 3.5 13ZM9.5 13Q12 13 12 15.5L12 20.5Q12 23 9.5 23Q7 23 7 20.5L7 15.5Q7 13 9.5 13ZM15 14.5Q15 15 15.5 15L20.5 15Q21 15 21 14.5Q21 14 20.5 14L15.5 14Q15 14 15 14.5ZM3.5 15Q3 15 3 15.5Q3 16 3.5 16Q4 16 4 15.5L4 15L3.5 15ZM9.5 15Q9 15 9 15.5L9 20.5Q9 21 9.5 21Q10 21 10 20.5L10 15.5Q10 15 9.5 15ZM15.5 18Q18 18 18 20.5Q18 23 15.5 23Q13 23 13 20.5L13 19Q13 18.9015 13.0192 18.8049Q13.0384 18.7083 13.0761 18.6173Q13.1138 18.5263 13.1685 18.4444Q13.2232 18.3625 13.2929 18.2929Q13.3625 18.2232 13.4444 18.1685Q13.5263 18.1138 13.6173 18.0761Q13.7083 18.0384 13.8049 18.0192Q13.9015 18 14 18L15.5 18ZM15.5 20L15 20L15 20.5Q15 21 15.5 21Q16 21 16 20.5Q16 20 15.5 20Z"
      fill="currentColor"
    />
  </svg>
);

export const SlideOut = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 21C19.654 21 21 19.654 21 18L21 6C21 4.346 19.654 3 18 3L6 3C4.346 3 3 4.346 3 6L3 18C3 19.654 4.346 21 6 21L18 21ZM6 5L9 5L9 19L6 19C5.449 19 5 18.551 5 18L5 6C5 5.449 5.449 5 6 5ZM18 19L11 19L11 5L18 5C18.551 5 19 5.449 19 6L19 18C19 18.551 18.551 19 18 19ZM16.0955 14.9999C15.9704 14.9999 15.8461 14.9455 15.7613 14.8401L13.6921 12.2686C13.5644 12.1095 13.5661 11.8824 13.6968 11.7255L15.8397 9.15401C15.991 8.97229 16.2614 8.94786 16.4435 9.09915C16.6253 9.25045 16.6497 9.52088 16.498 9.70261L14.5801 12.0045L16.4294 14.3026C16.5777 14.4869 16.5485 14.7569 16.3638 14.9052C16.285 14.9691 16.1898 14.9999 16.0955 14.9999Z"
      fill="currentColor"
    />
  </svg>
);

export const SidebarAttachRight = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 2L19 2Q22 2 22 5L22 19Q22 22 19 22L5 22Q2 22 2 19L2 5Q2 2 5 2ZM5 4L14 4L14 20L5 20Q4 20 4 19L4 5Q4 4 5 4ZM16 4L16 20L19 20Q20 20 20 19L20 5Q20 4 19 4L16 4ZM8.70711 8.29289L11.7071 11.2929Q11.7767 11.3625 11.8315 11.4444Q11.8862 11.5263 11.9239 11.6173Q11.9616 11.7083 11.9808 11.8049Q12 11.9015 12 12Q12 12.0985 11.9808 12.1951Q11.9616 12.2917 11.9239 12.3827Q11.8862 12.4737 11.8315 12.5556Q11.7767 12.6375 11.7071 12.7071L8.70711 15.7071Q8.63746 15.7767 8.55557 15.8315Q8.47368 15.8862 8.38268 15.9239Q8.29169 15.9616 8.19509 15.9808Q8.09849 16 8 16Q7.90151 16 7.80491 15.9808Q7.70831 15.9616 7.61732 15.9239Q7.52632 15.8862 7.44443 15.8315Q7.36254 15.7767 7.29289 15.7071Q7.22325 15.6375 7.16853 15.5556Q7.11381 15.4737 7.07612 15.3827Q7.03843 15.2917 7.01921 15.1951Q7 15.0985 7 15Q7 14.9015 7.01921 14.8049Q7.03843 14.7083 7.07612 14.6173Q7.11381 14.5263 7.16853 14.4444Q7.22325 14.3625 7.29289 14.2929L9.58579 12L7.29289 9.70711Q7.22325 9.63746 7.16853 9.55557Q7.11381 9.47368 7.07612 9.38268Q7.03843 9.29169 7.01921 9.19509Q7 9.09849 7 9Q7 8.90151 7.01921 8.80491Q7.03843 8.70831 7.07612 8.61732Q7.11381 8.52632 7.16853 8.44443Q7.22325 8.36254 7.29289 8.29289Q7.36254 8.22325 7.44443 8.16853Q7.52632 8.11381 7.61732 8.07612Q7.70831 8.03843 7.80491 8.01921Q7.90151 8 8 8Q8.09849 8 8.19509 8.01921Q8.29169 8.03843 8.38268 8.07612Q8.47368 8.11381 8.55557 8.16853Q8.63746 8.22325 8.70711 8.29289Z"
      fill="currentColor"
    />
  </svg>
);

export const SlideIn = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 21C19.654 21 21 19.654 21 18L21 6C21 4.346 19.654 3 18 3L6 3C4.346 3 3 4.346 3 6L3 18C3 19.654 4.346 21 6 21L18 21ZM6 5L9 5L9 19L6 19C5.449 19 5 18.551 5 18L5 6C5 5.449 5.449 5 6 5ZM18 19L11 19L11 5L18 5C18.551 5 19 5.449 19 6L19 18C19 18.551 18.551 19 18 19ZM14.0995 9.00021C14.2247 9.00021 14.349 9.05464 14.4338 9.16008L16.503 11.7316C16.6307 11.8906 16.629 12.1178 16.4982 12.2746L14.3554 14.8461C14.2041 15.0279 13.9337 15.0523 13.7515 14.901C13.5698 14.7497 13.5454 14.4793 13.6971 14.2975L15.615 11.9956L13.7657 9.69752C13.6174 9.51323 13.6465 9.24322 13.8312 9.09493C13.9101 9.03107 14.0052 9.00021 14.0995 9.00021Z"
      fill="currentColor"
    />
  </svg>
);

export const Sparkle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{ fill: "none", stroke: "currentColor" }}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
  </svg>
);

export const Sparkles = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{ fill: "none", stroke: "currentColor" }}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
    <path d="M20 2v4" />
    <path d="M22 4h-4" />
    <circle cx="4" cy="20" r="2" />
  </svg>
);

export const Split = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{ fill: "none", stroke: "currentColor" }}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 3h5v5" />
    <path d="M8 3H3v5" />
    <path d="M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3" />
    <path d="m15 9 6-6" />
  </svg>
);

export const Subagent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.06671 11L17.9333 11Q18 11.0912 18 11.25L18 14L17 14Q15 14 15 16L15 20Q15 22 17 22L21 22Q23 22 23 20L23 16Q23 14 21 14L20 14L20 11.25Q20 10.3815 19.488 9.74145Q18.8949 9 18 9L13 9L13 3Q13 2.90151 12.9808 2.80491Q12.9616 2.70831 12.9239 2.61732Q12.8862 2.52632 12.8315 2.44443Q12.7767 2.36254 12.7071 2.29289Q12.6375 2.22325 12.5556 2.16853Q12.4737 2.11381 12.3827 2.07612Q12.2917 2.03843 12.1951 2.01921Q12.0985 2 12 2Q11.9015 2 11.8049 2.01921Q11.7083 2.03843 11.6173 2.07612Q11.5263 2.11381 11.4444 2.16853Q11.3625 2.22325 11.2929 2.29289Q11.2232 2.36254 11.1685 2.44443Q11.1138 2.52632 11.0761 2.61732Q11.0384 2.70831 11.0192 2.80491Q11 2.90151 11 3L11 9L6 9Q5.10521 9 4.51204 9.74138Q4 10.3814 4 11.25L4 14L3 14Q1 14 1 16L1 20Q1 22 3 22L7 22Q9 22 9 20L9 16Q9 14 7 14L6 14L6 11.25Q6 11.0911 6.06671 11ZM3 16L7 16L7 20L3 20L3 16ZM17 16L21 16L21 20L17 20L17 16Z"
      fill="currentColor"
    />
  </svg>
);

export const Stop = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M20 5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5ZM22 19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19Z"
      fill="currentColor"
    />
  </svg>
);
export const StopCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="stop-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M14.75 8h-5.5A1.25 1.25 0 0 0 8 9.25v5.5A1.25 1.25 0 0 0 9.25 16h5.5A1.25 1.25 0 0 0 16 14.75v-5.5A1.25 1.25 0 0 0 14.75 8zM14 14h-4v-4h4z" />
      </g>
    </g>
  </svg>
);
export const Sun = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 18.9999C12.5523 18.9999 13 19.4477 13 19.9999V21.9999C13 22.5522 12.5523 22.9999 12 22.9999C11.4477 22.9999 11 22.5522 11 21.9999V19.9999C11 19.4477 11.4477 18.9999 12 18.9999Z" />
    <path d="M5.63281 16.9531C6.02331 16.5627 6.65637 16.5627 7.04688 16.9531C7.4373 17.3436 7.4373 17.9766 7.04688 18.3671L5.63672 19.7773C5.24619 20.1674 4.61307 20.1676 4.22266 19.7773C3.83235 19.3869 3.83251 18.7537 4.22266 18.3632L5.63281 16.9531Z" />
    <path d="M16.9531 16.9531C17.3436 16.5625 17.9767 16.5625 18.3672 16.9531L19.7773 18.3632C20.1676 18.7538 20.1678 19.3868 19.7773 19.7773C19.3869 20.1677 18.7538 20.1675 18.3633 19.7773L16.9531 18.3671C16.5626 17.9766 16.5626 17.3436 16.9531 16.9531Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6.99994C14.7614 6.99994 17 9.23852 17 11.9999C17 14.7614 14.7614 16.9999 12 16.9999C9.23858 16.9999 7 14.7614 7 11.9999C7 9.23852 9.23858 6.99994 12 6.99994ZM12 8.99994C10.3431 8.99994 9 10.3431 9 11.9999C9 13.6568 10.3431 14.9999 12 14.9999C13.6569 14.9999 15 13.6568 15 11.9999C15 10.3431 13.6569 8.99994 12 8.99994Z"
    />
    <path d="M4 10.9999C4.55228 10.9999 5 11.4477 5 11.9999C5 12.5522 4.55228 12.9999 4 12.9999H2C1.44772 12.9999 1 12.5522 1 11.9999C1 11.4477 1.44772 10.9999 2 10.9999H4Z" />
    <path d="M22 10.9999C22.5523 10.9999 23 11.4477 23 11.9999C23 12.5522 22.5523 12.9999 22 12.9999H20C19.4477 12.9999 19 12.5522 19 11.9999C19 11.4477 19.4477 10.9999 20 10.9999H22Z" />
    <path d="M4.22266 4.2226C4.61306 3.83219 5.24617 3.83243 5.63672 4.2226L7.04688 5.63275C7.43724 6.02329 7.43735 6.65634 7.04688 7.04681C6.6564 7.43724 6.02333 7.43717 5.63281 7.04681L4.22266 5.63666C3.83251 5.24612 3.8323 4.613 4.22266 4.2226Z" />
    <path d="M18.3633 4.2226C18.7538 3.8324 19.3869 3.83227 19.7773 4.2226C20.1677 4.61303 20.1676 5.24614 19.7773 5.63666L18.3672 7.04681C17.9767 7.43723 17.3436 7.43723 16.9531 7.04681C16.5627 6.65631 16.5627 6.02325 16.9531 5.63275L18.3633 4.2226Z" />
    <path d="M12 0.999939C12.5523 0.999939 13 1.44765 13 1.99994V3.99994C13 4.55222 12.5523 4.99994 12 4.99994C11.4477 4.99994 11 4.55222 11 3.99994V1.99994C11 1.44765 11.4477 0.999939 12 0.999939Z" />
  </svg>
);

//T
export const LLMOutput = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 14.9999C16.5523 14.9999 17 15.4477 17 15.9999C17 16.5522 16.5523 16.9999 16 16.9999H11C10.4477 16.9999 10 16.5522 10 15.9999C10 15.4477 10.4477 14.9999 11 14.9999H16Z"
      fill="currentColor"
    />
    <path
      d="M14 10.9999C14.5523 10.9999 15 11.4477 15 11.9999C15 12.5522 14.5523 12.9999 14 12.9999H8C7.44772 12.9999 7 12.5522 7 11.9999C7 11.4477 7.44772 10.9999 8 10.9999H14Z"
      fill="currentColor"
    />
    <path
      d="M16 6.99994C16.5523 6.99994 17 7.44765 17 7.99994C17 8.55222 16.5523 8.99994 16 8.99994H9C8.44772 8.99994 8 8.55222 8 7.99994C8 7.44765 8.44772 6.99994 9 6.99994H16Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 1.99994C20.6569 1.99994 22 3.34308 22 4.99994V18.9999C22 20.6568 20.6569 21.9999 19 21.9999H5C3.34315 21.9999 2 20.6568 2 18.9999V4.99994C2 3.34308 3.34315 1.99994 5 1.99994H19ZM5 3.99994C4.44772 3.99994 4 4.44765 4 4.99994V18.9999C4 19.5522 4.44772 19.9999 5 19.9999H19C19.5523 19.9999 20 19.5522 20 18.9999V4.99994C20 4.44765 19.5523 3.99994 19 3.99994H5Z"
      fill="currentColor"
    />
  </svg>
);

export const Text = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="text">
        <rect width="24" height="24" opacity="0" />
        <path d="M20 4H4a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V6h6v13H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2V6h6v2a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

export const Timer = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="timer">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.994 4.03164C12.9914 4.04002 12.9889 4.0485 12.988 4.058C17.487 4.552 21 8.372 21 13C21 17.963 16.962 22 12 22C7.038 22 3 17.963 3 13C3 8.372 6.513 4.552 11.012 4.058C11.0111 4.0485 11.0086 4.04002 11.006 4.03164C11.003 4.0215 11 4.0115 11 4V3H10C9.448 3 9 2.553 9 2C9 1.447 9.448 1 10 1H14C14.552 1 15 1.447 15 2C15 2.553 14.552 3 14 3H13V4C13 4.0115 12.997 4.0215 12.994 4.03164ZM12 19.75C8.278 19.75 5.25 16.722 5.25 13C5.25 9.278 8.278 6.25 12 6.25C15.722 6.25 18.75 9.278 18.75 13C18.75 16.722 15.722 19.75 12 19.75ZM16 13C16 12.447 15.552 12 15 12H13V10C13 9.447 12.552 9 12 9C11.448 9 11 9.447 11 10V13C11 13.553 11.448 14 12 14H15C15.552 14 16 13.553 16 13Z"
        fill="currentColor"
      />
      <mask
        id="mask0_0_1974"
        maskUnits="userSpaceOnUse"
        x="3"
        y="1"
        width="18"
        height="21"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.994 4.03164C12.9914 4.04002 12.9889 4.0485 12.988 4.058C17.487 4.552 21 8.372 21 13C21 17.963 16.962 22 12 22C7.038 22 3 17.963 3 13C3 8.372 6.513 4.552 11.012 4.058C11.0111 4.0485 11.0086 4.04002 11.006 4.03164C11.003 4.0215 11 4.0115 11 4V3H10C9.448 3 9 2.553 9 2C9 1.447 9.448 1 10 1H14C14.552 1 15 1.447 15 2C15 2.553 14.552 3 14 3H13V4C13 4.0115 12.997 4.0215 12.994 4.03164ZM12 19.75C8.278 19.75 5.25 16.722 5.25 13C5.25 9.278 8.278 6.25 12 6.25C15.722 6.25 18.75 9.278 18.75 13C18.75 16.722 15.722 19.75 12 19.75ZM16 13C16 12.447 15.552 12 15 12H13V10C13 9.447 12.552 9 12 9C11.448 9 11 9.447 11 10V13C11 13.553 11.448 14 12 14H15C15.552 14 16 13.553 16 13Z"
          fill="currentColor"
        />
      </mask>
    </g>
  </svg>
);

export const TimerOff = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.988 4.058C12.9889 4.0485 12.9914 4.04002 12.994 4.03164C12.997 4.0215 13 4.0115 13 4V3H14C14.552 3 15 2.553 15 2C15 1.447 14.552 1 14 1H10C9.448 1 9 1.447 9 2C9 2.553 9.448 3 10 3H11V4C11 4.0115 11.003 4.0215 11.006 4.03164C11.0086 4.04002 11.0111 4.0485 11.012 4.058C10.1864 4.14865 9.394 4.35131 8.65042 4.65041L10.4335 6.43348C10.9364 6.31352 11.4609 6.25 12 6.25C15.722 6.25 18.75 9.278 18.75 13C18.75 13.5391 18.6865 14.0636 18.5665 14.5665L20.3525 16.3525C20.7701 15.3159 21 14.1843 21 13C21 8.372 17.487 4.552 12.988 4.058ZM12 19.75C12.82 19.75 13.6063 19.603 14.334 19.334L16.0408 21.0408C14.825 21.6543 13.4521 22 12 22C7.038 22 3 17.963 3 13C3 11.8156 3.23007 10.6842 3.64786 9.64786L5.43348 11.4335C5.31353 11.9364 5.25 12.4609 5.25 13C5.25 16.722 8.278 19.75 12 19.75ZM3.85828 3.09123C3.35638 2.61722 2.56525 2.63982 2.09124 3.14172C1.61722 3.64362 1.63983 4.43475 2.14172 4.90877L20.1417 21.9088C20.6436 22.3828 21.4348 22.3602 21.9088 21.8583C22.3828 21.3564 22.3602 20.5652 21.8583 20.0912L3.85828 3.09123Z"
      fill="currentColor"
    />
  </svg>
);

export const ThumbsUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      fill="None"
      d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
    ></path>
  </svg>
);

export const ThumbsDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      fill="None"
      d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
    ></path>
  </svg>
);

export const Tokens = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path fill="none" d="M13.744 17.736a6 6 0 1 1-7.48-7.48" />
    <path fill="none" d="M15 6h1v4" />
    <path fill="none" d="m6.134 14.768.866-.5 2 3.464" />
    <circle fill="none" cx="16" cy="8" r="6" />
  </svg>
);

export const Trace = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 5C7 4.44772 6.55228 4 6 4C5.44772 4 5 4.44772 5 5V9V15C5 16.6569 6.34315 18 8 18H13.4375C13.8375 19.0243 14.834 19.75 16 19.75C17.5188 19.75 18.75 18.5188 18.75 17C18.75 15.4812 17.5188 14.25 16 14.25C14.834 14.25 13.8375 14.9757 13.4375 16H8C7.44772 16 7 15.5523 7 15V11H13.4375C13.8375 12.0243 14.834 12.75 16 12.75C17.5188 12.75 18.75 11.5188 18.75 10C18.75 8.48122 17.5188 7.25 16 7.25C14.834 7.25 13.8375 7.97566 13.4375 9H7V5ZM16 8.75C15.3096 8.75 14.75 9.30964 14.75 10C14.75 10.6904 15.3096 11.25 16 11.25C16.6904 11.25 17.25 10.6904 17.25 10C17.25 9.30964 16.6904 8.75 16 8.75ZM14.75 17C14.75 16.3096 15.3096 15.75 16 15.75C16.6904 15.75 17.25 16.3096 17.25 17C17.25 17.6904 16.6904 18.25 16 18.25C15.3096 18.25 14.75 17.6904 14.75 17Z"
    />
  </svg>
);

export const TypeScriptSVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1562 0C17.6222 0 18 0.37776 18 0.84375V17.1562C18 17.6222 17.6222 18 17.1562 18H0.84375C0.37776 18 0 17.6222 0 17.1562V0.84375C0 0.37776 0.37776 0 0.84375 0H17.1562ZM13.8662 7.3125C13.3993 7.3125 12.9568 7.36325 12.5391 7.46387C12.1213 7.56452 11.753 7.72097 11.4355 7.93457C11.118 8.14825 10.867 8.42118 10.6826 8.75195C10.4984 9.08268 10.4062 9.47838 10.4062 9.93848C10.4063 10.526 10.5751 11.0274 10.9131 11.4424C11.251 11.8573 11.7641 12.2085 12.4521 12.4961C12.7225 12.607 12.9746 12.7164 13.208 12.8232C13.4414 12.93 13.6435 13.0403 13.8135 13.1553C13.9833 13.2702 14.1175 13.3958 14.2158 13.5312C14.3143 13.6669 14.3633 13.8216 14.3633 13.9941C14.3632 14.1215 14.3329 14.2399 14.2715 14.3486C14.21 14.4573 14.1169 14.5518 13.9922 14.6318C13.8673 14.7119 13.7116 14.7742 13.5254 14.8193C13.339 14.8645 13.12 14.8877 12.8701 14.8877C12.4442 14.8877 12.0223 14.8121 11.6045 14.6621C11.1867 14.5122 10.7997 14.2872 10.4434 13.9873V15.96C10.7629 16.1242 11.1409 16.248 11.5771 16.3301C12.0132 16.4123 12.4729 16.4531 12.9561 16.4531C13.4271 16.4531 13.875 16.4078 14.2988 16.3174C14.723 16.227 15.0954 16.0787 15.415 15.8711C15.7345 15.6635 15.9874 15.3916 16.1738 15.0566C16.36 14.722 16.4531 14.3082 16.4531 13.8154C16.4531 13.4579 16.3994 13.1442 16.293 12.875C16.1864 12.606 16.0328 12.3667 15.832 12.1572C15.6314 11.9477 15.3908 11.7592 15.1104 11.5928C14.8298 11.4265 14.5133 11.2699 14.1611 11.1221C13.9032 11.0153 13.6716 10.9112 13.4668 10.8105C13.2619 10.7099 13.0877 10.6067 12.9443 10.502C12.801 10.3972 12.6901 10.286 12.6123 10.1689C12.5346 10.0519 12.4961 9.91928 12.4961 9.77148C12.4961 9.63615 12.5302 9.51399 12.5996 9.40527C12.6693 9.29639 12.7685 9.20308 12.8955 9.125C13.0225 9.04698 13.178 8.98551 13.3623 8.94238C13.5466 8.89927 13.7514 8.87793 13.9766 8.87793C14.1405 8.87793 14.3137 8.89039 14.4961 8.91504C14.6783 8.93969 14.8616 8.97794 15.0459 9.0293C15.2302 9.08065 15.4098 9.14557 15.584 9.22363C15.7579 9.30166 15.919 9.3915 16.0664 9.49414V7.65137C15.7673 7.53632 15.4403 7.45098 15.0859 7.39551C14.7316 7.34004 14.325 7.31251 13.8662 7.3125ZM2.53125 9.07812H5.0918V16.3125H7.12988V9.07812H9.70312V7.45312H2.53125V9.07812Z"
      fill="currentColor"
    />
  </svg>
);

export const Trash = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="trash">
        <rect width="24" height="24" opacity="0" />
        <path d="M21 6h-5V4.33A2.42 2.42 0 0 0 13.5 2h-3A2.42 2.42 0 0 0 8 4.33V6H3a1 1 0 0 0 0 2h1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8h1a1 1 0 0 0 0-2zM10 4.33c0-.16.21-.33.5-.33h3c.29 0 .5.17.5.33V6h-4zM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8h12z" />
      </g>
    </g>
  </svg>
);

export const Wrench = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5152 3.90101L15.4142 7.00004L17 8.58582L20.099 5.48778Q20.722 4.86085 21.5777 5.04029Q22.5029 5.2343 22.7535 6.14877Q23.9323 10.4363 20.551 13.3255Q17.4428 15.9814 13.7678 14.6464L6.32711 22.0871Q5.41273 23.0012 4.11998 23.001Q2.82723 23.0008 1.91327 22.0865Q0.999317 21.1722 0.999533 19.8795Q0.999749 18.5867 1.91401 17.6728L9.35458 10.2322Q8.01962 6.55725 10.6755 3.449Q13.5647 0.0676908 17.8531 1.24678Q18.7663 1.49696 18.9607 2.4214Q19.1401 3.27417 18.5152 3.90101ZM13.9931 5.59267L16.572 3.01546Q14.0015 2.63521 12.196 4.74823Q10.1323 7.16345 11.4421 10.0577Q11.4733 10.1268 11.4938 10.1997Q11.5143 10.2727 11.5235 10.3479Q11.5328 10.4232 11.5306 10.4989Q11.5284 10.5747 11.5148 10.6492Q11.5012 10.7238 11.4766 10.7955Q11.4519 10.8671 11.4167 10.9343Q11.3815 11.0014 11.3366 11.0625Q11.2917 11.1235 11.2381 11.1771L3.32799 19.0872Q2.99961 19.4155 2.99953 19.8798Q2.99946 20.3441 3.32772 20.6725Q3.65599 21.0009 4.12031 21.001Q4.58463 21.001 4.91289 20.6729L12.8229 12.7629Q12.8765 12.7093 12.9375 12.6644Q12.9986 12.6195 13.0657 12.5843Q13.1329 12.5491 13.2045 12.5244Q13.2762 12.4998 13.3508 12.4862Q13.4253 12.4726 13.5011 12.4704Q13.5768 12.4682 13.6521 12.4775Q13.7273 12.4867 13.8003 12.5072Q13.8732 12.5277 13.9423 12.5589Q16.8365 13.8687 19.2518 11.805Q21.364 10.0002 20.9847 7.43037L18.4 10.0141Q17 11.3864 15.5929 10.0071L13.9859 8.4Q12.6136 7 13.9859 5.6L13.9931 5.59267Z"
      fill="currentColor"
    />
  </svg>
);

export const Workflow = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 2L9 2Q12 2 12 5L12 9Q12 12 9 12L8 12L8 15Q8 16 9 16L12 16L12 15Q12 12 15 12L19 12Q22 12 22 15L22 19Q22 22 19 22L15 22Q12 22 12 19L12 18L9 18Q6 18 6 15L6 12L5 12Q2 12 2 9L2 5Q2 2 5 2ZM9 10L5 10Q4 10 4 9L4 5Q4 4 5 4L9 4Q10 4 10 5L10 9Q10 10 9 10ZM14 19L14 15Q14 14 15 14L19 14Q20 14 20 15L20 19Q20 20 19 20L15 20Q14 20 14 19Z"
      fill="currentColor"
    />
  </svg>
);

export const Experiment = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5 0.999939C16.0522 0.999939 16.5 1.44765 16.5 1.99994C16.5 2.55222 16.0522 2.99994 15.5 2.99994H15V7.99994C14.9999 8.16768 15.0426 8.33321 15.123 8.48041L20.6318 18.5595C20.8818 19.0164 21.0089 19.531 21 20.0517C20.991 20.5724 20.8466 21.0822 20.581 21.5302C20.3154 21.978 19.9377 22.3487 19.4853 22.6064C19.0894 22.8319 18.6482 22.9647 18.1953 22.9941L18 22.9999H5.99996C5.47939 22.9999 4.96795 22.864 4.51558 22.6064C4.06314 22.3487 3.68549 21.978 3.41988 21.5302C3.15425 21.0822 3.00895 20.5725 2.99996 20.0517C2.99097 19.531 3.11813 19.0164 3.36812 18.5595L5.56734 14.537C5.57282 14.5266 5.57811 14.516 5.58394 14.5058L8.87789 8.48041C8.95832 8.33322 9.00003 8.16767 8.99996 7.99994V2.99994H8.49996C7.94788 2.9997 7.49996 2.55208 7.49996 1.99994C7.49996 1.4478 7.94788 1.00018 8.49996 0.999939H15.5ZM5.123 19.5195C5.03967 19.6718 4.99696 19.8439 4.99996 20.0175C5.003 20.1909 5.05121 20.3605 5.13961 20.5097C5.22813 20.659 5.35404 20.7832 5.50484 20.8691C5.65562 20.9549 5.82645 20.9999 5.99996 20.9999H18.0009C18.1744 20.9999 18.3453 20.9549 18.4961 20.8691C18.6468 20.7832 18.7728 20.659 18.8613 20.5097C18.9497 20.3605 18.9979 20.1909 19.0009 20.0175C19.0039 19.8439 18.9612 19.6718 18.8779 19.5195L16.9541 15.9999H7.04683L5.123 19.5195ZM11 2.99994V7.99994L10.9951 8.18744C10.9678 8.62548 10.844 9.05292 10.6328 9.43939L8.13961 13.9999H15.8613L13.3681 9.43939C13.1569 9.05291 13.0331 8.6255 13.0058 8.18744L13 7.99994V2.99994H11Z"
      fill="currentColor"
    />
  </svg>
);

export const FlagTriangleRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.97266 1.00781C7.19657 1.0294 7.41463 1.09365 7.61621 1.19629L7.61719 1.19531L18.9854 6.87988C19.2514 7.00884 19.4818 7.20159 19.6553 7.43945L19.7266 7.54395L19.79 7.65332C19.9285 7.91318 20.0009 8.20428 20.001 8.5C20.0009 8.83797 19.906 9.16966 19.7266 9.45605C19.547 9.74237 19.2904 9.97276 18.9863 10.1201L18.9854 10.1191L7 16.1162V22C6.99985 22.5522 6.55219 23 6 23C5.44781 23 5.00015 22.5522 5 22V2.7998C4.99991 2.4906 5.07989 2.18652 5.23145 1.91699C5.38317 1.64725 5.60163 1.42032 5.86621 1.25977L6.07129 1.15332C6.28222 1.05994 6.51019 1.0075 6.74219 1L6.97266 1.00781ZM7 13.8809L17.7539 8.49902L7 3.12207V13.8809Z"
      fill="currentColor"
    />
  </svg>
);
